import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./stylesheets/home.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getHomeRequest,
  getHomeBg,
  getHomeSurrendered,
  getHomeCancelled,
  getBackBgSapCust,
  getBackSelectionType,
  createBgRequest,
  getBackBgDetails,
  getBackBgPermission,
  updateBgRequest,
  getBackBgAllSites,
  getBackSelectionImage,
  getUploadDetails,
  documentsUpload,
  deleteImage,
  getBGLog,
  getHomeRenewed,
  renewBgRequest,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";

import DatePicker from "react-datepicker";
import {
  Button,
  Dropdown,
  Offcanvas,
  FloatingLabel,
  Form,
  Table,
  Modal,
  Spinner,
} from "react-bootstrap";
import { FaMinusCircle, FaPlusCircle, FaDownload } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { GrPowerReset } from "react-icons/gr";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import FileViewer from "react-file-viewer";
import DocViewer from "react-doc-viewer";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { IoIosInformationCircle } from "react-icons/io";

export default class Home extends Component {
  constructor(props) {
    super(props);
    let params = new URLSearchParams(window.location.pathname);
    var BankName = params.get("BankName");
    if (BankName === "Total") {
      BankName = "";
    }
    var BGInPreClaim = params.get("BGInPreClaim");
    var BGInClaim = params.get("BGInClaim");
    var BGAfterClaim = params.get("BGAfterClaim");
    var startDateData = Moment(new Date());
    var endDateData = Moment(startDateData).endOf("month");
    var startDateOtData = Moment(new Date()).subtract(30, "days");
    var lasttdateData = new Date(endDateData);
    var lasttdateValidity = Moment(new Date());
    this.state = {
      startDate: new Date(),
      startDateOtData: new Date(startDateOtData),
      // lasttdateValidity:new Date(lasttdateValidity),
      lasttdatemax: new Date(),
      // endDate:new Date(),
      // lasttdate:lasttdateData,
      BankName: BankName,
      BGInPreClaim: BGInPreClaim,
      BGInClaim: BGInClaim,
      BGAfterClaim: BGAfterClaim,
      editReq: false,
      editDetails: false,
      expanded: false,
      editCloser: false,
      showData: false,
      scroll: false,
      backdrop: false,
      placement: "end",
      saveBtn: false,
      renewalFlag: false,
      parentReqID: "",
      childReqID: null,
      showRenewModal: false,
      lodingImagData: false,
      AllowedFileExtensions: "",
      bgDetailsDataCustomer: "",
      showTooltipBox: false,
      MaxAllowedSize: "",
      bgdetails: [],
      documentArr: [],
      selectionImage: [],
      BGLogs: [],
      ImageType: "",
      typeImage: "",
      Comment: "",
      docs: "",
      listStatusId: [
        { key: 1, value: "Request" },
        { key: 2, value: "BG" },
        { key: 3, value: "Surrender" },
        { key: 4, value: "Cancelled" },
        { key: 5, value: "Renewed" },
      ],
      imageLoop: [],
      imageCount: 0,
      listTechnicians: [],
      listBranch: [],
      listBranchData: [],
      expanded: [0, 1],
      currnetmonthdata: new Date(),
      statusId: 1,
      selectedStatus: "Request",
      requestStatus: "10",
      image: require("../../../assets/images/blank-photo-image.png"),
      submitbtn: false,
      loading: false,
      showbtn: false,
      appBtnFin: false,
      ReqDate: "",
      InitialReqStatus: "",
      NotesApprovel: "",
      NotesEditOther: "",
      StampPaperValue: "",
      StartCustomerHandOverDate: "",
      permissionArr: [],
      reqEncID: "",
      loadingData: "No data found",
      isError: {
        timeVali: "",
        timeValiClaim: "",
      },
    };

    this.handleMouseEnterFetch = this.handleMouseEnterFetch.bind(this);
    this.handleMouseLeaveFetch = this.handleMouseLeaveFetch.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const accesstokendata = localStorage.getItem("access_token");
    const authToken = localStorage.getItem("auth");
    const decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    const userPermissions = decoded.user_permissions;

    let editBtn = false;
    let saveBtn = false;
    let appBtn = false;
    let appBtnFin = false;

    const ApplicationPermissions = userPermissions[0].ApplicationPermissions;

    // Set permissions
    if (
      ApplicationPermissions.some((obj) => obj.PermissionCode === "CREATE_BG")
    ) {
      editBtn = true;
    }

    if (
      ApplicationPermissions.some(
        (obj) =>
          obj.PermissionCode === "SUBMIT_BG" ||
          obj.PermissionCode === "FINANCE_BG"
      )
    ) {
      saveBtn = true;
    }

    if (
      ApplicationPermissions.some((obj) => obj.PermissionCode === "APPROVE_BG")
    ) {
      appBtn = true;
    }

    if (
      ApplicationPermissions.some((obj) => obj.PermissionCode === "FINANCE_BG")
    ) {
      appBtnFin = true;
    }

    this.setState({
      editBtn,
      saveBtn,
      appBtn,
      appBtnFin,
    });

    // Fetch all data
    this.fetchInitialData(userId);
  }

  fetchInitialData = async (userId) => {
    try {
      const statusIdArr = [
        { key: 1, value: "Request" },
        { key: 2, value: "BG" },
        { key: 3, value: "Surrender" },
        { key: 4, value: "Cancelled" },
        { key: 5, value: "Renewed" },
      ];

      let selectedStatus = statusIdArr[0].value;
      let statusId = statusIdArr[0].key;

      if (
        this.state.BankName ||
        (this.state.BGInPreClaim &&
          this.state.BGInClaim &&
          this.state.BGAfterClaim)
      ) {
        selectedStatus = statusIdArr[1].value;
        statusId = statusIdArr[1].key;

        this.setState({ loadingImageData: true });
        await this.handleInputFetch(selectedStatus);
      }

      // Fetching all the data concurrently
      const [
        responseBgImage,
        responseAllSites,
        responseUploadsDetails,
        responseBgType,
        responseBank,
        responseBankIssue,
        responseSapCust,
        responseDivision,
      ] = await Promise.all([
        getBackSelectionImage(),
        getBackBgAllSites({ UserID: userId }),
        getUploadDetails(),
        getBackSelectionType({ selectionType: 10 }),
        getBackSelectionType({ selectionType: 20 }),
        getBackSelectionType({ selectionType: 40 }),
        getBackBgSapCust({ customer_type: "Domestic" }),
        getBackSelectionType({ selectionType: 30 }),
      ]);

      // Process BgImageTypeArr
      const BgImageTypeArr = responseBgImage.map((image) => ({
        SelectionID: image.SelectionID,
        SelectionValue: image.SelectionValue,
        SelectionType: image.SelectionType,
        AllowMultiple: image.AllowMultiple,
      }));

      // Process BranchArr
      const BranchArr = responseAllSites.map((site) => ({
        key: site.SiteID,
        value: site.BranchName,
        BranchID: site.BranchID,
        ApplicationTenantID: site.ApplicationTenantID,
        ApplicationID: site.ApplicationID,
        BusinessUnit: site.BusinessUnit,
        BusinessUnitSelectionID: site.BusinessUnitSelectionID,
      }));

      // Process Selection arrays
      const BgTypeIdArr = responseBgType.map((type) => ({
        key: type.SelectionID,
        value: type.SelectionValue,
      }));

      const BankIdArr = responseBank.map((bank) => ({
        key: bank.SelectionID,
        value: bank.SelectionValue,
      }));

      const BankIssueIdArr = responseBankIssue.map((issue) => ({
        key: issue.SelectionID,
        value: issue.SelectionValue,
      }));

      const SapCustIdArr = responseSapCust.map((cust) => ({
        key: cust.CardCode,
        value: cust.CardName,
        CutomerType: cust.CutomerType,
      }));

      const DivisionIdArr = responseDivision.reduce((acc, div) => {
        const filteredBranches = BranchArr.filter(
          (branch) =>
            branch.BusinessUnitSelectionID === parseInt(div.SelectionID)
        );
        if (filteredBranches.length > 0) {
          acc.push({ key: div.SelectionID, value: div.SelectionValue });
        }
        return acc;
      }, []);

      // Update state with fetched data
      this.setState({
        listStatusId: statusIdArr,
        selectedStatus,
        statusId,
        BgTypeIdArr,
        BankIdArr,
        SapCustIdArr,
        BankIssueIdArr,
        DivisionIdArr,
        imageLoop: [
          {
            imageId: 0,
            imageData: "",
            image: require("../../../assets/images/blank-photo-image.png"),
          },
        ],
        listBranchData: BranchArr,
        selectionImage: BgImageTypeArr,
        uploadDetailsArr: responseUploadsDetails,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.setState({ loadingImageData: false });
    }
  };

  handleInputFetch = (event) => {
    var submitbtn = true;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    var loadingData = "No data found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    var bgHomeArr = [];
    var statusId = event;
    if (statusId === undefined) {
      statusId = this.state.selectedStatus;
    }

    var sendData = {
      userId: userId,
    };
    const fetchBgdetails = async () => {
      var datarespBg = [];
      if (statusId === "Request") {
        const responsebg = await getHomeRequest(sendData);
        datarespBg = responsebg;
      } else if (statusId === "BG") {
        const responsebg = await getHomeBg(sendData);
        datarespBg = responsebg;
      } else if (statusId === "Surrender") {
        const responsebg = await getHomeSurrendered(sendData);
        datarespBg = responsebg;
      }
      if (statusId === "Cancelled") {
        const responsebg = await getHomeCancelled(sendData);
        datarespBg = responsebg;
      }
      if (statusId === "Renewed") {
        const responsebg = await getHomeRenewed(sendData);
        datarespBg = responsebg;
      }

      if (datarespBg.length > 0) {
        var BGInPreClaim = this.state.BGInPreClaim;
        var BGInClaim = this.state.BGInClaim;
        var BGAfterClaim = this.state.BGAfterClaim;
        var todayDate = Moment(new Date()).format("DD-MMM-YYYY");
        if (
          BGInPreClaim !== "" &&
          BGInPreClaim !== null &&
          BGInPreClaim !== undefined
        ) {
          var preClaimArr = [];
          for (let index = 0; index < datarespBg.length; index++) {
            var validationDate = Moment(datarespBg[index].ValidityTo).format(
              "DD-MMM-YYYY"
            );
            var dateVali = Moment(validationDate).isSameOrAfter(todayDate);
            if (dateVali === true) {
              const element = datarespBg[index];
              preClaimArr.push(element);
            }
          }
          bgHomeArr = preClaimArr;
        } else if (
          BGInClaim !== "" &&
          BGInClaim !== null &&
          BGInClaim !== undefined
        ) {
          var preClaimArr = [];
          for (let index = 0; index < datarespBg.length; index++) {
            var validationDate = Moment(datarespBg[index].ValidityTo).format(
              "DD-MMM-YYYY"
            );
            var dateVali = Moment(todayDate).isSameOrAfter(validationDate);
            var validationDateClaim = Moment(
              datarespBg[index].ClaimPeriod
            ).format("DD-MMM-YYYY");
            var dateValiClam =
              Moment(validationDateClaim).isSameOrAfter(todayDate);
            if (dateVali === true && dateValiClam === true) {
              const element = datarespBg[index];
              preClaimArr.push(element);
            }
          }
          bgHomeArr = preClaimArr;
        } else if (
          BGAfterClaim !== "" &&
          BGAfterClaim !== null &&
          BGAfterClaim !== undefined
        ) {
          var preClaimArr = [];
          for (let index = 0; index < datarespBg.length; index++) {
            var validationDate = Moment(datarespBg[index].ClaimPeriod).format(
              "DD-MMM-YYYY"
            );
            var dateVali = Moment(todayDate).isSameOrAfter(validationDate);
            if (dateVali === true) {
              const element = datarespBg[index];
              preClaimArr.push(element);
            }
          }
          bgHomeArr = preClaimArr;
        } else {
          bgHomeArr = datarespBg;
          this.setState({
            lodingImagData: false,
          });
        }
      } else {
        loadingData = "No data found";
        this.setState({
          lodingImagData: false,
        });
      }

      this.setState({
        bgdetails: bgHomeArr,
        loading: false,
        loadingData: loadingData,
        lodingImagData: false,
      });
    };
    fetchBgdetails();
  };

  handleDropdown = (key, event) => {
    this.setState({
      selectedStatus: event.target.innerHTML,
      statusId: key,
      bgdetails: [],
      submitbtn: false,
      showData: false,
    });
  };

  handleInputChange = (event) => {
    var startDateData = event;
    var endDateData = Moment(startDateData).endOf("month");
    var lasttdateData = new Date(endDateData);
    var curretnMonth = Moment(startDateData).format("MM");
    var selectedMonth = Moment(new Date()).format("MM");

    var sameMonth = Moment(curretnMonth).isSame(selectedMonth);

    if (sameMonth === true) {
      startDateData = new Date();
    }

    this.setState({
      currnetmonthdata: event,
      startDate: new Date(startDateData),
      lasttdate: lasttdateData,
      allowancedetails: [],
      submitbtn: false,
      showData: false,
    });
  };

  handleDataAddDetails = (event) => {
    event.preventDefault();
    // const accesstokendata =  localStorage.getItem('access_token');
    // const readData = JSON.parse(accesstokendata);
    // const userId =  readData.userdata.user_id;

    var newelement = {
      imageId: 0,
      imageData: "",
      image: require("../../../assets/images/blank-photo-image.png"),
    };
    this.setState((prevState) => ({
      imageLoop: [...prevState.imageLoop, newelement],
    }));
  };

  handleChangeEnd = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    var validation = Moment(selectedDate).isSameOrAfter(
      this.state.StartDateTime
    );
    if (validation === true) {
      this.setState({
        EndDateTime: selectedDate,
      });
    } else {
      MySwal.fire(
        "<p>Job End date must be either on the same date as the job start date or greater than that<p>"
      );
    }
  };

  handleChangeStart = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    var selectedDateLast = moment(selectedDate).add(1, "days");
    this.setState({
      OrderDate: selectedDate,
      lasttdateValidity: new Date(selectedDateLast),
      ValidityFrom: "",
    });
  };

  handleChangeStartValFrom = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ValidityFrom: selectedDate,
      startDateValTo: new Date(Moment(selectedDate).add(1, "days")),
      ValidityTo: "",
    });
  };

  handleChangeStartValTo = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ValidityTo: selectedDate,
      startDateClaim: selectedDate,
      ClaimPeriod: "",
    });
  };

  handleChangeStartValFromEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ValidityFromEdit: selectedDate,
      startDateValToEdit: new Date(Moment(selectedDate).add(1, "days")),
      ValidityToEdit: "",
    });
  };

  handleChangeStartEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    var selectedDateLast = moment(selectedDate).add(1, "days");
    this.setState({
      OrderDateEdit: selectedDate,
      lasttdateValidity: new Date(selectedDateLast),
      ValidityFromEdit: "",
      ValidityToEdit: "",
    });
  };

  handleChangeStartValToEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ValidityToEdit: selectedDate,
      startDateClaimEdit: selectedDate,
      ClaimPeriodEdit: "",
    });
  };

  handleChangeEndClaim = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ClaimPeriod: selectedDate,
    });
  };

  handleChangeEndClaimEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ClaimPeriodEdit: selectedDate,
    });
  };

  handleChangeStartValidity = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ValidityDateEdit: selectedDate,
    });
  };

  handleChangeBGDateEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      BGDateEdit: selectedDate,
      StartCustomerHandOverDate: new Date(moment(selectedDate).add(1, "days")),
      CustomerHandOverDate: "",
    });
  };

  handleChangeSurrenderEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      SurrenderEdit: selectedDate,
    });
  };

  handleChangeDateOfApplicationEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      DateOfApplicationEdit: selectedDate,
    });
  };

  handleChangeDischargeDate = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      DischargeOfLiabilityByBankEdit: selectedDate,
    });
  };

  handleChangeDateOfReturnByCustomer = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      DateOfReturnByCustomer: selectedDate,
    });
  };

  handleChangeClaimDateEdit = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ClaimDateEdit: selectedDate,
    });
  };

  handleChangeApplication = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      ApplicationEdit: selectedDate,
      startDateBg: new Date(Moment(selectedDate).add(1, "days")),
      BGDateEdit: "",
    });
  };

  handleChangeCustomerHandOverDate = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    this.setState({
      CustomerHandOverDate: selectedDate,
    });
  };

  handleOnChange = (selected) => {
    this.setState({
      engg: selected,
    });
  };

  handleCloseModal = (selected) => {
    this.setState({
      showModal: false,
      showRenewModal: false,
      ImageType: "",
      image: require("../../../assets/images/blank-photo-image.png"),
      AllowedFileExtensions: "",
      MaxAllowedSize: "",
      imageId: "",
      imageData: "",
    });
  };

  handleShowModal = (selected) => {
    this.setState({
      showModal: true,
    });
  };

  handleCloseModalBig = (selected) => {
    this.setState({
      showModalBig: false,
    });
  };

  handleShowModalBig = async (selected, DocumentID) => {
    var ApplicationTenantID = 0;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    if (
      accessselectedtentant !== "" &&
      accessselectedtentant !== null &&
      accessselectedtentant !== undefined
    ) {
      const readDataSelected = JSON.parse(accessselectedtentant);
      ApplicationTenantID = readDataSelected.ApplicationTenantID;
    }
    var urlObject = selected;
    const token = JSON.parse(localStorage.getItem("auth"));
    if (DocumentID !== "" && DocumentID !== null && DocumentID !== undefined) {
      var url =
        process.env.REACT_APP_API_URL +
        "/documents/" +
        DocumentID +
        "/?application_tenant_id=" +
        ApplicationTenantID;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const blob = await res.blob();
      urlObject = URL.createObjectURL(blob);
    }

    this.setState({
      showModalBig: true,
      // viewFile:selected,
      viewFile: urlObject,
    });
  };

  handleImageDownload = async (selected, DocumentID) => {
    var ApplicationTenantID = 0;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    if (
      accessselectedtentant !== "" &&
      accessselectedtentant !== null &&
      accessselectedtentant !== undefined
    ) {
      const readDataSelected = JSON.parse(accessselectedtentant);
      ApplicationTenantID = readDataSelected.ApplicationTenantID;
    }
    const token = JSON.parse(localStorage.getItem("auth"));
    if (DocumentID !== "" && DocumentID !== null && DocumentID !== undefined) {
      var url =
        process.env.REACT_APP_API_URL +
        "documents/" +
        DocumentID +
        "/?application_tenant_id=" +
        ApplicationTenantID;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const blob = await res.blob();
      var urlObject = URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = urlObject;
      alink.download = selected;
      alink.click();
    }
  };

  handleDataChangeOtherImageType = (event) => {
    event.preventDefault();
    var uploadDetailsArr = this.state.uploadDetailsArr;
    const filteredData = uploadDetailsArr.filter((obj) => {
      return obj.SelectionType === parseInt(event.target.value);
    });
    if (filteredData.length > 0) {
      this.setState({
        AllowedFileExtensions: filteredData[0].AllowedFileExtensions,
        MaxAllowedSize: 4 + " MB",
      });
    }
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleChangeImageDataOther = (event) => {
    const MySwal = withReactContent(Swal);
    var checkImageData = event.target.files[0];
    var uploadDetailsArr = this.state.uploadDetailsArr;
    const filteredData = uploadDetailsArr.filter((obj) => {
      return obj.SelectionType === parseInt(this.state.ImageType);
    });

    if (
      event.target.files[0] !== "" &&
      event.target.files[0] !== null &&
      event.target.files[0] !== undefined
    ) {
      if (filteredData.length > 0) {
        var fileName = event.target.files[0].name;
        var patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        var fileExtension = fileName.match(patternFileExtension);
        const MIN_FILE_SIZE = 4 * 1024;
        const fileSizeKiloBytes = checkImageData.size / 1024;
        const uploadedFileType = checkImageData.type;
        const fileType = filteredData[0].AllowedFileExtensions;
        const fileTypeArray = fileType.split(",");
        const filteredFileType = fileTypeArray.find(
          (element) =>
            element === fileExtension[0] ||
            element.toUpperCase() === fileExtension[0]
        );
        if (
          filteredFileType !== undefined &&
          filteredFileType !== null &&
          filteredFileType !== ""
        ) {
          if (fileSizeKiloBytes < MIN_FILE_SIZE) {
            this.setState({
              imageId: checkImageData.name,
              typeImage: fileExtension[1],
              imageData: checkImageData,
              image: URL.createObjectURL(event.target.files[0]),
            });
          } else {
            var msg = "Maximum file size allowed " + 4 + "MB";
            MySwal.fire(msg);
          }
        } else {
          var msg = "File type not allowed";
          MySwal.fire(msg);
        }
      } else {
        var msg = "Please select file type first";
        MySwal.fire(msg);
      }
    }
  };

  handleChangeImage = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    var checkImageData = this.state.imageData;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.display_name;
    var uploadDetailsArr = this.state.uploadDetailsArr;
    const filteredData = uploadDetailsArr.filter((obj) => {
      return obj.SelectionType === parseInt(this.state.ImageType);
    });
    var selectionImage = this.state.selectionImage;
    const filteredDataMain = selectionImage.filter((obj) => {
      return obj.SelectionType === parseInt(this.state.ImageType);
    });
    if (
      checkImageData !== "" &&
      checkImageData !== null &&
      checkImageData !== undefined
    ) {
      if (filteredData.length > 0) {
        var fileName = checkImageData.name;
        var patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        var fileExtension = fileName.match(patternFileExtension);
        const MIN_FILE_SIZE = filteredData[0].MaxAllowedSize * 1024;
        const fileSizeKiloBytes = checkImageData.size / 1024;
        const uploadedFileType = checkImageData.type;
        const fileType = filteredData[0].AllowedFileExtensions;
        const fileTypeArray = fileType.split(",");
        const filteredFileType = fileTypeArray.find(
          (element) =>
            element === fileExtension[0] ||
            element.toUpperCase() === fileExtension[0]
        );
        if (
          filteredFileType !== undefined &&
          filteredFileType !== null &&
          filteredFileType !== ""
        ) {
          this.setState({
            lodingImagData: true,
          });
          var uploadedOn = Moment(new Date()).format("DD-MMM-YYYY HH:mm");
          var userData = this.state.documentArr;
          var element = {};
          element.SelectionID = filteredDataMain[0].SelectionID;
          element.SelectionType = parseInt(this.state.ImageType);
          element.FileName = this.state.imageId;
          element.imageUrl = this.state.image;
          element.imageData = this.state.imageData;
          element.Description = this.state.Comment;
          element.BGDocumentID = 0;
          element.UploadedOn = uploadedOn;
          element.DocumentID = 0;
          element.ImageType = 1;
          element.SelectionValue = filteredDataMain[0].SelectionValue;
          element.DeleteFlag = true;
          element.UploadedBy = userId;
          userData.push(element);
          this.setState(
            {
              documentArr: userData,
            },
            () => {
              this.setState({
                imageId: "",
                imageData: "",
                ImageType: "",
                image: require("../../../assets/images/blank-photo-image.png"),
                showModal: false,
                lodingImagData: false,
                Comment: "",
              });
            }
          );
        } else {
          var msg = "File type not allowed";
          MySwal.fire(msg);
        }
      } else {
        var msg = "Please select file type first";
        MySwal.fire(msg);
      }
    } else {
      var msg = "Please select file";
      MySwal.fire(msg);
    }
  };

  handleDataRemoveImage = (event) => {
    var msg = "Are you sure you want to delete?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          documentArr: this.state.documentArr.filter(function (
            documentArrData,
            i
          ) {
            if (i === event && documentArrData.DocumentID !== 0) {
              deleteImage(documentArrData);
            }
            return i !== event;
          }),
        });
      }
    });
  };

  handleRenewBgRequest = async (event) => {
    event.preventDefault();

    // Show confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to renew this request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, renew it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);

      const authToken = localStorage.getItem("auth");
      var decoded = jwt_decode(authToken);
      const userId = decoded.user_id;

      var validation = Moment(
        Moment(this.state.ValidityTo).format("YYYY-MM-DD")
      ).isAfter(Moment(this.state.ValidityFrom).format("YYYY-MM-DD"));
      var validationClaim = Moment(
        Moment(this.state.ClaimPeriod).format("YYYY-MM-DD")
      ).isSameOrAfter(Moment(this.state.ValidityTo).format("YYYY-MM-DD"));

      const submitData = {
        ValidityTo: Moment(this.state.ValidityToEdit).format("YYYY-MM-DD"),
        ClaimPeriod: Moment(this.state.ClaimPeriodEdit).format("YYYY-MM-DD"),
        ModifiedBy: userId,
        reqID: this.state.ReqIDEdit,
      };

      try {
        const responseRenewed = await renewBgRequest(submitData);

        // Assuming the response needs to be parsed as JSON manually
        const responseData =
          typeof responseRenewed === "string"
            ? JSON.parse(responseRenewed)
            : responseRenewed;

        console.log("responseData", responseData);

        const newReqId =
          responseData.new_req_id || responseData.data?.new_req_id; // Adjust based on actual structure

        const newBgNum = responseData.bg_num || responseData.data?.bg_num;

        if (newReqId) {
          console.log("New request ID:", newReqId);

          this.setState({ showRenewModal: false, showData: false });

          // Show success message with the new request ID
          Swal.fire({
            title: "Request Renewed!",
            text: `A new request # ${newReqId} has been created for the renewal of BG#: ${newBgNum}.`,
            icon: "success",
          });
        } else {
          throw new Error("new_req_id not found in response");
        }
      } catch (error) {
        console.error("Error renewing the request", error);

        // Show error message
        Swal.fire({
          title: "Error!",
          text: "Something went wrong while renewing the request. Please try again.",
          icon: "error",
        });
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // Show cancellation message
      Swal.fire({
        title: "Cancelled",
        text: "The renewal request was not created.",
        icon: "info",
      });
    }
  };

  handleMouseEnterFetch() {
    this.setState({ showTooltipBox: true });
  }

  handleMouseLeaveFetch() {
    this.setState({ showTooltipBox: false });
  }

  handleSubmitRequest = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    // var resp = this.handleFormValidation(this.state);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    // const currentMonthdata = this.state.currnetmonthdata;
    var validation = Moment(
      Moment(this.state.ValidityTo).format("YYYY-MM-DD")
    ).isAfter(Moment(this.state.ValidityFrom).format("YYYY-MM-DD"));
    var validationClaim = Moment(
      Moment(this.state.ClaimPeriod).format("YYYY-MM-DD")
    ).isSameOrAfter(Moment(this.state.ValidityTo).format("YYYY-MM-DD"));
    if (validation === true) {
      if (validationClaim === true) {
        var documentArr = this.state.documentArr;
        var AllDocuments = [];
        const addBgRequest = async () => {
          this.setState({
            lodingImagData: true,
          });
          if (documentArr.length > 0) {
            for (let index = 0; index < documentArr.length; index++) {
              const element = {};
              if (documentArr[index].ImageType === 1) {
                var uploadedDocument = {
                  document: documentArr[index].imageData,
                  selection_type: documentArr[index].SelectionType,
                };
                var resp = await documentsUpload(uploadedDocument);
                if (!resp) {
                  this.setState({
                    lodingImagData: false,
                  });
                }
                var documentData = resp.document_id;
                var documentIdDate = documentData;
                element.SelectionID = documentArr[index].SelectionID;
                element.DocumentID = documentIdDate;
                element.FileName = documentArr[index].FileName;
                element.Description = documentArr[index].Description;
                element.UploadedBy = userId;
                AllDocuments.push(element);
              }
            }
          }

          var submitData = {
            Branch: parseInt(this.state.Branch),
            SAPCustid: this.state.SAPCustid,
            Division: parseInt(this.state.Division),
            OrderNum: this.state.OrderNum,
            IsOrderTender: this.state.IsOrderTender,
            OrderDate: Moment(this.state.OrderDate).format("YYYY-MM-DD"),
            OrderValue: parseInt(this.state.OrderValue),
            BGValueReq: parseInt(this.state.BGValueReq),
            // StampPaperValue: parseInt(this.state.StampPaperValue),
            PreferredBank: parseInt(this.state.PreferredBank),
            ValidityFrom: Moment(this.state.ValidityFrom).format("YYYY-MM-DD"),
            ValidityTo: Moment(this.state.ValidityTo).format("YYYY-MM-DD"),
            ClaimPeriod: Moment(this.state.ClaimPeriod).format("YYYY-MM-DD"),
            BGType: parseInt(this.state.BGType),
            Notes: this.state.Notes,
            ModifiedBy: userId,
            BGDocuments: AllDocuments,
          };
          const responseScheduled = await createBgRequest(submitData);
          if (responseScheduled === 200) {
            this.handleInputFetch();
            this.setState({
              showData: false,
              Division: "",
              Branch: "",
              SAPCustid: "",
              OrderNum: "",
              IsOrderTender: "",
              OrderDate: "",
              OrderValue: "",
              BGValueReq: "",
              PreferredBank: "",
              // StampPaperValue: "",
              ValidityFrom: "",
              ValidityTo: "",
              ClaimPeriod: "",
              BGType: "",
              Notes: "",
              NotesEditOther: "",
              // StampPaperValue: "",
              NotesApprovel: "",
              AllowedFileExtensions: "",
              MaxAllowedSize: "",
              ImageType: "",
              documentArr: [],
              lodingImagData: false,
              isError: {
                timeVali: "",
                timeValiClaim: "",
              },
            });
          }
        };
        var msg = "Are you sure you want to create?.";
        Swal.fire({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            addBgRequest();
          }
        });
      } else {
        let isError = this.state.isError;
        isError["timeValiClaim"] =
          'Claim Period date must be either on the same date as the "Validity To" date or greater than that';
        this.setState({ isError });
      }
    } else {
      let isError = this.state.isError;
      isError["timeVali"] =
        "Validity To date must be greater than Validity Form date";
      this.setState({ isError });
    }
  };

  handleSubmitEdit = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    const accesstokendata = localStorage.getItem("access_token");
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    const ApplicationTenantID = readDataSelected.ApplicationTenantID;
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    const NewReqStatus = this.state.ReqStatus;
    var validation = Moment(
      Moment(this.state.ValidityToEdit).format("YYYY-MM-DD")
    ).isAfter(Moment(this.state.ValidityFromEdit).format("YYYY-MM-DD"));
    var validationClaim = Moment(
      Moment(this.state.ClaimPeriodEdit).format("YYYY-MM-DD")
    ).isSameOrAfter(Moment(this.state.ValidityToEdit).format("YYYY-MM-DD"));
    // var validation = Moment(this.state.ValidityToEdit).isSameOrAfter(this.state.ValidityFromEdit);
    if (validation === true) {
      if (validationClaim === true) {
        const updateBgRequestdata = async () => {
          var BGDateData = "";
          var documentArr = this.state.documentArr;
          var AllDocuments = [];
          this.setState({
            lodingImagData: true,
          });
          if (documentArr.length > 0) {
            for (let index = 0; index < documentArr.length; index++) {
              const element = {};
              if (documentArr[index].ImageType === 1) {
                var uploadedDocument = {
                  document: documentArr[index].imageData,
                  selection_type: documentArr[index].SelectionType,
                };
                var resp = await documentsUpload(uploadedDocument);
                if (!resp) {
                  this.setState({
                    lodingImagData: false,
                  });
                }
                var documentData = resp.document_id;
                var documentIdDate = documentData;
                element.SelectionID = documentArr[index].SelectionID;
                element.DocumentID = documentIdDate;
                element.FileName = documentArr[index].FileName;
                element.Description = documentArr[index].Description;
                element.UploadedBy = userId;
                AllDocuments.push(element);
              }
            }
          }

          if (
            this.state.BGDateEdit !== "" &&
            this.state.BGDateEdit !== null &&
            this.state.BGDateEdit !== undefined
          ) {
            BGDateData = Moment(this.state.BGDateEdit).format("YYYY-MM-DD");
          }

          var DischargeOfLiabilityByBankEdit = "";
          if (
            this.state.DischargeOfLiabilityByBankEdit !== "" &&
            this.state.DischargeOfLiabilityByBankEdit !== null &&
            this.state.DischargeOfLiabilityByBankEdit !== undefined
          ) {
            DischargeOfLiabilityByBankEdit = Moment(
              this.state.DischargeOfLiabilityByBankEdit
            ).format("YYYY-MM-DD");
          }

          var DateOfApplication = "";
          if (
            this.state.ApplicationEdit !== "" &&
            this.state.ApplicationEdit !== null &&
            this.state.ApplicationEdit !== undefined
          ) {
            DateOfApplication = Moment(this.state.ApplicationEdit).format(
              "YYYY-MM-DD"
            );
          }

          var CustomerHandOverDate = "";
          if (
            this.state.CustomerHandOverDate !== "" &&
            this.state.CustomerHandOverDate !== null &&
            this.state.CustomerHandOverDate !== undefined
          ) {
            CustomerHandOverDate = Moment(
              this.state.CustomerHandOverDate
            ).format("YYYY-MM-DD");
          }

          var DateOfReturnByCustomer = "";
          if (
            this.state.DateOfReturnByCustomer !== "" &&
            this.state.DateOfReturnByCustomer !== null &&
            this.state.DateOfReturnByCustomer !== undefined
          ) {
            DateOfReturnByCustomer = Moment(
              this.state.DateOfReturnByCustomer
            ).format("YYYY-MM-DD");
          }

          var SurrenderEdit = "";
          if (
            this.state.SurrenderEdit !== "" &&
            this.state.SurrenderEdit !== null &&
            this.state.SurrenderEdit !== undefined
          ) {
            SurrenderEdit = Moment(this.state.SurrenderEdit).format(
              "YYYY-MM-DD"
            );
          }

          var submitData = {
            ReqID: this.state.ReqIDEdit,
            Division: this.state.DivisionEdit,
            Branch: this.state.BranchEdit,
            SAPCustid: this.state.SAPCustEdit,
            OrderNum: this.state.OrderNumEdit,
            IsOrderTender: this.state.IsOrderTenderEdit,
            OrderDate: Moment(this.state.OrderDateEdit).format("YYYY-MM-DD"),
            OrderValue: this.state.OrderValueEdit,
            BGValueReq: this.state.BGValueEdit,
            PreferredBank: this.state.PreferredBankEdit,
            ValidityFrom: Moment(this.state.ValidityFromEdit).format(
              "YYYY-MM-DD"
            ),
            ValidityTo: Moment(this.state.ValidityToEdit).format("YYYY-MM-DD"),
            ClaimPeriod: Moment(this.state.ClaimPeriodEdit).format(
              "YYYY-MM-DD"
            ),
            BGType: this.state.BGTypeEdit,
            NewReqStatus: parseInt(NewReqStatus),
            Notes: this.state.NotesEdit,
            // StampPaperValue: this.state.StampPaperValue,
            BusyCustomer: this.state.BusyCustomer,
            BGNum: this.state.BGNumEdit,
            BGDate: BGDateData,
            IssuingBank: this.state.IssuingBankEdit,
            BGValueActual: this.state.BGValueActualEdit,
            SurrenderToBank: SurrenderEdit,
            DischargeOfLiabilityByBank: DischargeOfLiabilityByBankEdit,
            ModifiedBy: userId,
            ApplicationTenantID: ApplicationTenantID,
            DateOfApplication: DateOfApplication,
            CustomerHandOverDate: "9999-12-31",
            DateOfReturnByCustomer: DateOfReturnByCustomer,
            BGDocuments: AllDocuments,
            reqID_enc: this.state.reqEncID,
          };
          const responseScheduled = await updateBgRequest(submitData);
          if (responseScheduled === 200) {
            this.handleInputFetch();
            var sendLogData = {
              ReqID: this.state.ReqIDEdit,
            };
            // this.handleOnExpand(sendLogData);
            this.setState({
              showData: false,
              Branch: "",
              SAPCustid: "",
              OrderNum: "",
              IsOrderTender: "",
              OrderDate: "",
              OrderValue: "",
              BGValueReq: "",
              PreferredBank: "",
              ValidityFrom: "",
              ValidityTo: "",
              ClaimPeriod: "",
              BGType: "",
              Notes: "",
              NotesEdit: "",
              NotesEditOther: "",
              // StampPaperValue: "",
              NotesApprovel: "",
              AllowedFileExtensions: "",
              MaxAllowedSize: "",
              ImageType: "",
              documentArr: [],
              lodingImagData: false,
              isError: {
                timeVali: "",
                timeValiClaim: "",
              },
            });
          }
        };
        var msg = "Are you sure you want to update?.";
        Swal.fire({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            updateBgRequestdata();
          }
        });
      } else {
        let isError = this.state.isError;
        isError["timeValiClaim"] =
          'Claim Period date must be either on the same date as the "Validity To" date or greater than that';
        this.setState({ isError });
      }
    } else {
      let isError = this.state.isError;
      isError["timeVali"] =
        "Validity To date must be greater than Validity Form date";
      this.setState({ isError });
    }
  };

  handleSubmitAproval = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    const accesstokendata = localStorage.getItem("access_token");
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    const ApplicationTenantID = readDataSelected.ApplicationTenantID;
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    const NewReqStatus = this.state.ReqStatus;
    const updateBgRequestdata = async () => {
      var BGDateData = "";
      this.setState({
        lodingImagData: true,
      });
      if (
        this.state.BGDateEdit !== "" &&
        this.state.BGDateEdit !== null &&
        this.state.BGDateEdit !== undefined
      ) {
        BGDateData = Moment(this.state.BGDateEdit).format("YYYY-MM-DD");
      }

      var DischargeOfLiabilityByBankEdit = "";
      if (
        this.state.DischargeOfLiabilityByBankEdit !== "" &&
        this.state.DischargeOfLiabilityByBankEdit !== null &&
        this.state.DischargeOfLiabilityByBankEdit !== undefined
      ) {
        DischargeOfLiabilityByBankEdit = Moment(
          this.state.DischargeOfLiabilityByBankEdit
        ).format("YYYY-MM-DD");
      }

      var SurrenderEdit = "";
      if (
        this.state.SurrenderEdit !== "" &&
        this.state.SurrenderEdit !== null &&
        this.state.SurrenderEdit !== undefined
      ) {
        SurrenderEdit = Moment(this.state.SurrenderEdit).format("YYYY-MM-DD");
      }
      var submitData = {
        ReqID: this.state.ReqIDEdit,
        Division: this.state.DivisionEdit,
        Branch: this.state.BranchEdit,
        SAPCustid: this.state.SAPCustEdit,
        OrderNum: this.state.OrderNumEdit,
        IsOrderTender: this.state.IsOrderTenderEdit,
        OrderDate: Moment(this.state.OrderDateEdit).format("YYYY-MM-DD"),
        OrderValue: this.state.OrderValueEdit,
        BGValueReq: this.state.BGValueEdit,
        PreferredBank: this.state.PreferredBankEdit,
        ValidityFrom: Moment(this.state.ValidityFromEdit).format("YYYY-MM-DD"),
        ValidityTo: Moment(this.state.ValidityToEdit).format("YYYY-MM-DD"),
        ClaimPeriod: Moment(this.state.ClaimPeriodEdit).format("YYYY-MM-DD"),
        BGType: this.state.BGTypeEdit,
        NewReqStatus: 30,
        Notes: this.state.NotesApprovel,
        // StampPaperValue: this.state.StampPaperValue,
        BusyCustomer: this.state.BusyCustomer,
        BGNum: parseInt(this.state.BGNumEdit),
        BGDate: BGDateData,
        IssuingBank: this.state.IssuingBankEdit,

        BGValueActual: this.state.BGValueActualEdit,
        SurrenderToBank: SurrenderEdit,
        DischargeOfLiabilityByBank: DischargeOfLiabilityByBankEdit,
        ModifiedBy: userId,
        ApplicationTenantID: ApplicationTenantID,
        BGDocuments: [],
        reqID_enc: this.state.reqEncID,
      };
      const responseScheduled = await updateBgRequest(submitData);
      if (responseScheduled === 200) {
        this.handleInputFetch();
        var sendLogData = {
          ReqID: this.state.ReqIDEdit,
        };
        //  this.handleOnExpand(sendLogData);
        this.setState({
          showData: false,
          Branch: "",
          SAPCustid: "",
          OrderNum: "",
          IsOrderTender: "",
          OrderDate: "",
          OrderValue: "",
          BGValueReq: "",
          PreferredBank: "",
          ValidityFrom: "",
          ValidityTo: "",
          // StampPaperValue: "",
          ClaimPeriod: "",
          BGType: "",
          Notes: "",
          NotesEdit: "",
          // StampPaperValue: "",
          NotesApprovel: "",
          AllowedFileExtensions: "",
          MaxAllowedSize: "",
          ImageType: "",
          documentArr: [],
          lodingImagData: false,
          isError: {
            timeVali: "",
            timeValiClaim: "",
          },
        });
      }
    };
    var msg = "Are you sure you want to update?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        updateBgRequestdata();
      }
    });
  };

  handleSubmitRequestEdit = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    const accesstokendata = localStorage.getItem("access_token");
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    const ApplicationTenantID = readDataSelected.ApplicationTenantID;
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    const NewReqStatus = this.state.ReqStatus;
    var validation = Moment(
      Moment(this.state.ValidityToEdit).format("YYYY-MM-DD")
    ).isAfter(Moment(this.state.ValidityFromEdit).format("YYYY-MM-DD"));
    var validationClaim = Moment(
      Moment(this.state.ClaimPeriodEdit).format("YYYY-MM-DD")
    ).isSameOrAfter(Moment(this.state.ValidityToEdit).format("YYYY-MM-DD"));

    // var validation = Moment(this.state.ValidityToEdit).isSameOrAfter(this.state.ValidityFromEdit);
    if (validation === true) {
      if (validationClaim === true) {
        const updateBgRequestdata = async () => {
          var BGDateData = "";
          var documentArr = this.state.documentArr;
          var AllDocuments = [];
          this.setState({
            lodingImagData: true,
          });
          if (documentArr.length > 0) {
            for (let index = 0; index < documentArr.length; index++) {
              const element = {};
              if (documentArr[index].ImageType === 1) {
                var uploadedDocument = {
                  document: documentArr[index].imageData,
                  selection_type: documentArr[index].SelectionType,
                };
                var resp = await documentsUpload(uploadedDocument);

                if (!resp) {
                  this.setState({
                    lodingImagData: false,
                  });
                }
                var documentData = resp.document_id;

                var documentIdDate = documentData;
                element.SelectionID = documentArr[index].SelectionID;
                element.DocumentID = documentIdDate;
                element.FileName = documentArr[index].FileName;
                element.Description = documentArr[index].Description;
                element.UploadedBy = userId;
                AllDocuments.push(element);
              }
            }
          }
          if (
            this.state.BGDateEdit !== "" &&
            this.state.BGDateEdit !== null &&
            this.state.BGDateEdit !== undefined
          ) {
            BGDateData = Moment(this.state.BGDateEdit).format("YYYY-MM-DD");
          }

          var DischargeOfLiabilityByBankEdit = "";
          if (
            this.state.DischargeOfLiabilityByBankEdit !== "" &&
            this.state.DischargeOfLiabilityByBankEdit !== null &&
            this.state.DischargeOfLiabilityByBankEdit !== undefined
          ) {
            DischargeOfLiabilityByBankEdit = Moment(
              this.state.DischargeOfLiabilityByBankEdit
            ).format("YYYY-MM-DD");
          }

          var DateOfApplication = "";
          if (
            this.state.ApplicationEdit !== "" &&
            this.state.ApplicationEdit !== null &&
            this.state.ApplicationEdit !== undefined
          ) {
            DateOfApplication = Moment(this.state.ApplicationEdit).format(
              "YYYY-MM-DD"
            );
          }

          var CustomerHandOverDate = "";
          if (
            this.state.CustomerHandOverDate !== "" &&
            this.state.CustomerHandOverDate !== null &&
            this.state.CustomerHandOverDate !== undefined
          ) {
            CustomerHandOverDate = Moment(
              this.state.CustomerHandOverDate
            ).format("YYYY-MM-DD");
          }

          var DateOfReturnByCustomer = "";
          if (
            this.state.DateOfReturnByCustomer !== "" &&
            this.state.DateOfReturnByCustomer !== null &&
            this.state.DateOfReturnByCustomer !== undefined
          ) {
            DateOfReturnByCustomer = Moment(
              this.state.DateOfReturnByCustomer
            ).format("YYYY-MM-DD");
          }

          var SurrenderEdit = "";
          if (
            this.state.SurrenderEdit !== "" &&
            this.state.SurrenderEdit !== null &&
            this.state.SurrenderEdit !== undefined
          ) {
            SurrenderEdit = Moment(this.state.SurrenderEdit).format(
              "YYYY-MM-DD"
            );
          }
          var submitData = {
            ReqID: this.state.ReqIDEdit,
            Division: this.state.DivisionEdit,
            Branch: this.state.BranchEdit,
            SAPCustid: this.state.SAPCustEdit,
            OrderNum: this.state.OrderNumEdit,
            IsOrderTender: this.state.IsOrderTenderEdit,
            OrderDate: Moment(this.state.OrderDateEdit).format("YYYY-MM-DD"),
            OrderValue: this.state.OrderValueEdit,
            BGValueReq: this.state.BGValueReqEdit,
            PreferredBank: this.state.PreferredBankEdit,
            ValidityFrom: Moment(this.state.ValidityFromEdit).format(
              "YYYY-MM-DD"
            ),
            ValidityTo: Moment(this.state.ValidityToEdit).format("YYYY-MM-DD"),
            ClaimPeriod: Moment(this.state.ClaimPeriodEdit).format(
              "YYYY-MM-DD"
            ),
            BGType: this.state.BGTypeEdit,
            NewReqStatus: NewReqStatus,
            Notes: this.state.NotesEditOther,
            // StampPaperValue: this.state.StampPaperValue,
            BusyCustomer: this.state.BusyCustomer,
            BGNum: this.state.BGNumEdit,
            BGDate: BGDateData,
            IssuingBank: this.state.IssuingBankEdit,
            BGValueActual: this.state.BGValueActualEdit,
            SurrenderToBank: SurrenderEdit,
            DischargeOfLiabilityByBank: DischargeOfLiabilityByBankEdit,
            ModifiedBy: userId,
            ApplicationTenantID: ApplicationTenantID,
            DateOfApplication: DateOfApplication,
            CustomerHandOverDate: CustomerHandOverDate
              ? CustomerHandOverDate
              : "9999-12-31",
            DateOfReturnByCustomer: DateOfReturnByCustomer,
            BGDocuments: AllDocuments,
            reqID_enc: this.state.reqEncID,
          };
          const responseScheduled = await updateBgRequest(submitData);
          if (responseScheduled === 200) {
            this.handleInputFetch();
            var sendLogData = {
              ReqID: this.state.ReqIDEdit,
            };
            //  this.handleOnExpand(sendLogData);
            this.setState({
              showData: false,
              Branch: "",
              SAPCustid: "",
              OrderNum: "",
              IsOrderTender: "",
              OrderDate: "",
              OrderValue: "",
              BGValueReq: "",
              PreferredBank: "",
              ValidityFrom: "",
              ValidityTo: "",
              ClaimPeriod: "",
              BGType: "",
              NotesEdit: "",
              NotesEditOther: "",
              // StampPaperValue: "",
              NotesApprovel: "",
              AllowedFileExtensions: "",
              MaxAllowedSize: "",
              ImageType: "",
              documentArr: [],
              lodingImagData: false,
              isError: {
                timeVali: "",
                timeValiClaim: "",
              },
            });
          }
        };
        var msg = "Are you sure you want to update?.";
        Swal.fire({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            updateBgRequestdata();
          }
        });
      } else {
        let isError = this.state.isError;
        isError["timeValiClaim"] =
          'Claim Period date must be either on the same date as the "Validity To" date or greater than that';
        this.setState({ isError });
      }
    } else {
      let isError = this.state.isError;
      isError["timeVali"] =
        "Validity To date must be greater than Validity Form date";
      this.setState({ isError });
    }
  };

  handleSubmitReject = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    const accesstokendata = localStorage.getItem("access_token");
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    const ApplicationTenantID = readDataSelected.ApplicationTenantID;
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    const NewReqStatus = this.state.ReqStatus;
    const updateBgRequestdata = async () => {
      var BGDateData = "";
      this.setState({
        lodingImagData: true,
      });
      if (
        this.state.BGDateEdit !== "" &&
        this.state.BGDateEdit !== null &&
        this.state.BGDateEdit !== undefined
      ) {
        BGDateData = Moment(this.state.BGDateEdit).format("YYYY-MM-DD");
      }
      var DischargeOfLiabilityByBankEdit = "";
      if (
        this.state.DischargeOfLiabilityByBankEdit !== "" &&
        this.state.DischargeOfLiabilityByBankEdit !== null &&
        this.state.DischargeOfLiabilityByBankEdit !== undefined
      ) {
        DischargeOfLiabilityByBankEdit = Moment(
          this.state.DischargeOfLiabilityByBankEdit
        ).format("YYYY-MM-DD");
      }
      var SurrenderEdit = "";
      if (
        this.state.SurrenderEdit !== "" &&
        this.state.SurrenderEdit !== null &&
        this.state.SurrenderEdit !== undefined
      ) {
        SurrenderEdit = Moment(this.state.SurrenderEdit).format("YYYY-MM-DD");
      }
      var submitData = {
        ReqID: this.state.ReqIDEdit,
        Division: this.state.DivisionEdit,
        Branch: this.state.BranchEdit,
        SAPCustid: this.state.SAPCustEdit,
        OrderNum: this.state.OrderNumEdit,
        OrderDate: Moment(this.state.OrderDateEdit).format("YYYY-MM-DD"),
        OrderValue: this.state.OrderValueEdit,
        BGValueReq: this.state.BGValueEdit,
        IsOrderTender: this.state.IsOrderTenderEdit,
        PreferredBank: this.state.PreferredBankEdit,
        ValidityFrom: Moment(this.state.ValidityFromEdit).format("YYYY-MM-DD"),
        ValidityTo: Moment(this.state.ValidityToEdit).format("YYYY-MM-DD"),
        ClaimPeriod: Moment(this.state.ClaimPeriodEdit).format("YYYY-MM-DD"),
        BGType: this.state.BGTypeEdit,
        NewReqStatus: 10,
        Notes: this.state.NotesApprovel,
        // StampPaperValue: this.state.StampPaperValue,
        BusyCustomer: this.state.BusyCustomer,
        BGNum: parseInt(this.state.BGNumEdit),
        BGDate: BGDateData,
        IssuingBank: this.state.IssuingBankEdit,
        BGValueActual: this.state.BGValueActualEdit,
        SurrenderToBank: SurrenderEdit,
        DischargeOfLiabilityByBank: DischargeOfLiabilityByBankEdit,
        ModifiedBy: userId,
        ApplicationTenantID: ApplicationTenantID,
        BGDocuments: [],
        reqID_enc: this.state.reqEncID,
      };
      const responseScheduled = await updateBgRequest(submitData);
      if (responseScheduled === 200) {
        this.handleInputFetch();
        var sendLogData = {
          ReqID: this.state.ReqIDEdit,
        };
        //  this.handleOnExpand(sendLogData);
        this.setState({
          showData: false,
          Branch: "",
          SAPCustid: "",
          OrderNum: "",
          Code: "",
          IsOrderTender: "",
          OrderDate: "",
          OrderValue: "",
          BGValueReq: "",
          PreferredBank: "",
          ValidityFrom: "",
          ValidityTo: "",
          ClaimPeriod: "",
          BGType: "",
          NotesEdit: "",
          NotesApprovel: "",
          // StampPaperValue: "",
          AllowedFileExtensions: "",
          MaxAllowedSize: "",
          ImageType: "",
          documentArr: [],
          lodingImagData: false,
          isError: {
            timeVali: "",
            timeValiClaim: "",
          },
        });
      }
    };
    var msg = "Are you sure you want to update?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        updateBgRequestdata();
      }
    });
  };

  handleBgRenewModal = () => {
    this.setState({
      showRenewModal: true,
    });
  };

  handleClose = (event) => {
    this.setState({
      showData: false,
      showRenewModal: false,
      Division: "",
      Branch: "",
      SAPCustid: "",
      OrderNum: "",
      Code: "",
      IsOrderTender: "",
      OrderDate: "",
      OrderValue: "",
      BGValueReq: "",
      PreferredBank: "",
      ValidityFrom: "",
      ValidityTo: "",
      ClaimPeriod: "",
      BGType: "",
      Notes: "",
      NotesEdit: "",
      NotesEditOther: "",
      // StampPaperValue: "",
      NotesApprovel: "",
      ImageType: "",
      documentArr: [],
      isError: {
        timeVali: "",
        timeValiClaim: "",
      },
      // BranchEdit: '',
      // OrderNumEdit:'',
      // OrderDateEdit:'',
      // OrderValueEdit:'',
      // BGValueReqEdit:'',
      // PreferredBankEdit:'',
      // ValidityFromEdit:'',
      // ValidityToEdit:'',
      // ClaimPeriodEdit:'',
      // BGTypeEdit:'',
      // NotesEdit:'',
    });
  };

  handleDataChangeOther = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleNumberChange = (event) => {
    event.preventDefault();
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|\.)/, "");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    // if (event.target.name === "StampPaperValue") {
    //   if (/^\d{1,5}$/.test(val)) {
    //     // Update state if the value passes both checks
    //     this.setState({
    //       [event.target.name]: val,
    //     });
    //   } else return;
    // }
    this.setState({ [event.target.name]: value });
  };

  handleDataChangeOtherStatus = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: parseInt(event.target.value),
    });
  };

  handleDataChangeDrop = (selectedOption) => {
    this.setState({ SAPCustid: selectedOption ? selectedOption.value : "" });
  };

  handleDataChangeDropEdit = (selectedOption) => {
    this.setState({ SAPCustEdit: selectedOption ? selectedOption.value : "" });
  };

  handleDataChangeOtherDivision = (event) => {
    event.preventDefault();
    var listBranchData = this.state.listBranchData;
    const filteredData = listBranchData.filter((obj) => {
      return obj.BusinessUnitSelectionID === parseInt(event.target.value);
    });
    if (filteredData.length > 0) {
      this.setState({
        listBranch: filteredData,
      });
    } else {
      this.setState({
        listBranch: [],

        lodingImagData: false,
      });
    }
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleReset = (event) => {
    var statusIdArr = this.state.listStatusId;
    var selectedStatus = statusIdArr[0].value;
    var statusId = statusIdArr[0].key;

    this.setState({
      selectedStatus: selectedStatus,
      statusId: statusId,
      bgdetails: [],
      submitbtn: false,
      showData: false,
      BGInPreClaim: "",
      BGInClaim: "",
      BGAfterClaim: "",
    });
  };

  handleOnExpand = (row, isExpand, rowIndex, e) => {
    const fetchBGLogs = async () => {
      var sendData = {
        ReqIDEnc: row.ReqIDEnc,
      };
      const responsebgLogs = await getBGLog(sendData);
      const datarespbgLogs = await responsebgLogs;
      this.setState((state, props) => {
        state.BGLogs[row.ReqID] = datarespbgLogs;
        return {
          BGLogs: state.BGLogs,
        };
      });
    };
    fetchBGLogs();
  };

  handleShow = (event, row) => {
    this.setState({
      renewalFlag: row?.CanBeRenewed,
      parentReqID: row?.ParentReqID,
      childReqID: row?.ChildReqID,
    });

    var showAdd = false;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    var imageLoop = [
      {
        imageId: 0,
        imageData: "",
        image: require("../../../assets/images/blank-photo-image.png"),
      },
    ];
    if (
      event === "Acceptance" ||
      event === "Approval" ||
      event === "Requester" ||
      event === "BG Details" ||
      event === "BG Closure"
    ) {
      this.setState({
        lodingImagData: true,
        StatusCode: parseInt(row.Code),
      });
      const editBgRequest = async () => {
        this.setState({
          reqEncID: row.ReqIDEnc,
        });

        var senddata = {
          ReqIDEnc: row.ReqIDEnc,
          UserID: userId,
        };
        var senddataper = {
          ReqIDEnc: row.ReqIDEnc,
          UserID: userId,
        };
        const authToken = localStorage.getItem("auth");
        var decoded = jwt_decode(authToken);
        var userpermisson = decoded.user_permissions;

        var ApplicationPermissions = userpermisson[0].ApplicationPermissions;
        const filteredData = ApplicationPermissions.filter((obj) => {
          return obj.PermissionCode === "CREATE_BG";
        });
        const filteredDataApp = ApplicationPermissions.filter((obj) => {
          return obj.PermissionCode === "FINANCE_BG";
        });

        const filteredDataAproval = ApplicationPermissions.filter((obj) => {
          return obj.PermissionCode === "APPROVE_BG";
        });

        // if(filteredData.length > 0 && row.Code === 70){
        //   this.setState({
        //     editDetails:true,
        //   })
        // }else{
        //   this.setState({
        //     editDetails:false,
        //   })
        // }

        // if(filteredDataApp.length > 0 && row.Code === 60 || row.Code === 50){
        //   this.setState({
        //     editReq:true,
        //   })
        // }else{
        //   this.setState({
        //     editReq:false,
        //   })
        // }

        if (filteredData.length > 0 && row.Code === 70) {
          this.setState({
            editReq: true,
          });
        } else if (filteredDataApp.length > 0 && row.Code === 80) {
          this.setState({
            editReq: true,
          });
        } else if (
          (filteredDataApp.length > 0 && row.Code === 60) ||
          row.Code === 50
        ) {
          this.setState({
            editReq: true,
          });
        } else if (
          (filteredDataApp.length > 0 && row.Code === 30) ||
          row.Code === 40
        ) {
          this.setState({
            editReq: true,
          });
        } else if (filteredDataAproval.length > 0 && row.Code === 20) {
          this.setState({
            appBtn: true,
          });
        } else if (filteredData.length > 0 && row.Code === 10) {
          this.setState({
            editReq: true,
          });
        } else {
          this.setState({
            editReq: false,

            lodingImagData: false,
          });
        }

        // if(filteredDataApp.length > 0 && row.Code === 30 || row.Code === 40){
        //   this.setState({
        //     editReq:true,
        //   })
        // }else{
        //   this.setState({
        //     editReq:false,
        //   })
        // }

        // if(filteredDataAproval.length > 0 && row.Code === 20){
        //   this.setState({
        //     appBtn:true,
        //   })
        // }else{
        //   this.setState({
        //     appBtn:false,
        //   })
        // }

        // if(filteredData.length > 0 && row.Code === 10){
        //   this.setState({
        //     editReq:true,
        //   })
        // }else{
        //   this.setState({
        //     editReq:false,
        //   })
        // }

        var permissionArr = [];
        var bgDetailsData = await getBackBgDetails(senddata);
        var bgDetailsDataPer = await getBackBgPermission(senddataper);

        if (bgDetailsData || bgDetailsDataPer === undefined) {
          this.setState({
            lodingImagData: false,
            bgDetailsDataCustomer: bgDetailsData,
          });
        }

        if (bgDetailsDataPer.length > 0) {
          for (let index = 0; index < bgDetailsDataPer.length; index++) {
            const element = {};
            element.DestinationStatusCode =
              bgDetailsDataPer[index].DestinationStatusCode;
            element.SourceStatusCode = bgDetailsDataPer[index].SourceStatusCode;
            element.SourceStatus = bgDetailsDataPer[index].SourceStatus;
            element.DestinationStatus =
              bgDetailsDataPer[index].DestinationStatus;
            element.DestinationStatusCodeValue =
              bgDetailsDataPer[index].DestinationStatusCodeValue;
            permissionArr.push(element);
          }
          this.setState({
            permissionArr: permissionArr,
            // saveBtn:true
          });
        } else {
          console.log("errorrrrrrrrrr");
          this.setState({
            permissionArr: permissionArr,
            lodingImagData: false,
            // saveBtn:false
          });
        }
        if (
          bgDetailsData !== "" &&
          bgDetailsData !== null &&
          bgDetailsData !== undefined
        ) {
          console.log("errorrrrrrrrrr");

          this.setState({
            lodingImagData: false,
          });

          var BGDate = "";
          var OrderDate = "";
          var ValidityFrom = "";
          var ValidityTo = "";
          var ClaimPeriod = "";
          var DateOfApplication = "";
          var DischargeOfLiabilityByBank = "";
          var CustomerHandOverDate = "";
          var DateOfReturnByCustomer = "";
          var OrderDateDisplay = "";
          var StartCustomerHandOverDate = "";
          var SurrenderEdit = "";
          if (
            bgDetailsData.OrderDate !== "" &&
            bgDetailsData.OrderDate !== null &&
            bgDetailsData.OrderDate !== undefined &&
            bgDetailsData.OrderDate !== "9999-12-31" &&
            bgDetailsData.OrderDate !== "1900-01-01"
          ) {
            OrderDate = new Date(bgDetailsData.OrderDate);
            OrderDateDisplay = Moment(bgDetailsData.ReqDate).format(
              "DD-MMM-YYYY"
            );
          }

          if (
            bgDetailsData.BGDate !== "" &&
            bgDetailsData.BGDate !== null &&
            bgDetailsData.BGDate !== undefined &&
            bgDetailsData.BGDate !== "9999-12-31" &&
            bgDetailsData.BGDate !== "1900-01-01"
          ) {
            BGDate = new Date(bgDetailsData.BGDate);
            StartCustomerHandOverDate = new Date(
              Moment(bgDetailsData.BGDate).add(0, "days")
            );
          }

          if (
            bgDetailsData.ValidityFrom !== "" &&
            bgDetailsData.ValidityFrom !== null &&
            bgDetailsData.ValidityFrom !== undefined &&
            bgDetailsData.ValidityFrom !== "9999-12-31" &&
            bgDetailsData.ValidityFrom !== "1900-01-01"
          ) {
            ValidityFrom = new Date(bgDetailsData.ValidityFrom);
          }

          if (
            bgDetailsData.ValidityTo !== "" &&
            bgDetailsData.ValidityTo !== null &&
            bgDetailsData.ValidityTo !== undefined &&
            bgDetailsData.ValidityTo !== "9999-12-31"
          ) {
            ValidityTo = new Date(bgDetailsData.ValidityTo);
          }

          if (
            bgDetailsData.ClaimPeriod !== "" &&
            bgDetailsData.ClaimPeriod !== null &&
            bgDetailsData.ClaimPeriod !== undefined &&
            bgDetailsData.ClaimPeriod !== "9999-12-31"
          ) {
            ClaimPeriod = new Date(bgDetailsData.ClaimPeriod);
          }

          if (
            bgDetailsData.DischargeOfLiabilityByBank !== "" &&
            bgDetailsData.DischargeOfLiabilityByBank !== null &&
            bgDetailsData.DischargeOfLiabilityByBank !== undefined &&
            bgDetailsData.DischargeOfLiabilityByBank !== "9999-12-31" &&
            bgDetailsData.DischargeOfLiabilityByBank !== "1900-01-01"
          ) {
            DischargeOfLiabilityByBank = new Date(
              bgDetailsData.DischargeOfLiabilityByBank
            );
          }

          if (
            bgDetailsData.CustomerHandOverDate !== "" &&
            bgDetailsData.CustomerHandOverDate !== null &&
            bgDetailsData.CustomerHandOverDate !== undefined &&
            bgDetailsData.CustomerHandOverDate !== "9999-12-31" &&
            bgDetailsData.CustomerHandOverDate !== "1900-01-01"
          ) {
            CustomerHandOverDate = new Date(bgDetailsData.CustomerHandOverDate);
          }

          if (
            bgDetailsData.DateOfReturnByCustomer !== "" &&
            bgDetailsData.DateOfReturnByCustomer !== null &&
            bgDetailsData.DateOfReturnByCustomer !== undefined &&
            bgDetailsData.DateOfReturnByCustomer !== "9999-12-31" &&
            bgDetailsData.DateOfReturnByCustomer !== "1900-01-01"
          ) {
            DateOfReturnByCustomer = new Date(
              bgDetailsData.DateOfReturnByCustomer
            );
          }

          if (
            bgDetailsData.DateOfApplication !== "" &&
            bgDetailsData.DateOfApplication !== null &&
            bgDetailsData.DateOfApplication !== undefined &&
            bgDetailsData.DateOfApplication !== "9999-12-31" &&
            bgDetailsData.DateOfApplication !== "1900-01-01"
          ) {
            DateOfApplication = new Date(bgDetailsData.DateOfApplication);
          }

          if (
            bgDetailsData.SurrenderToBank !== "" &&
            bgDetailsData.SurrenderToBank !== null &&
            bgDetailsData.SurrenderToBank !== undefined &&
            bgDetailsData.SurrenderToBank !== "9999-12-31" &&
            bgDetailsData.SurrenderToBank !== "1900-01-01"
          ) {
            SurrenderEdit = new Date(bgDetailsData.SurrenderToBank);
          }

          // var listBranchData = this.state.listBranchData;
          //   const filteredData = listBranchData.filter(obj => {
          //     return obj.key === parseInt(bgDetailsData.Branch);
          //   });
          //   if(filteredData.length > 0){
          //     this.setState({
          //       listBranch: filteredData,
          //     });
          //   }

          var listBranchData = this.state.listBranchData;
          const filteredData = listBranchData.filter((obj) => {
            return (
              obj.BusinessUnitSelectionID === parseInt(bgDetailsData.Division)
            );
          });
          if (filteredData.length > 0) {
            this.setState({
              listBranch: filteredData,
            });
          } else {
            this.setState({
              listBranch: [],

              lodingImagData: false,
            });
          }
          var ReqDate = new Date(Moment(bgDetailsData.ReqDate).add(0, "days"));
          var lasttdateValidity = new Date(
            Moment(bgDetailsData.OrderDate).add(1, "days")
          );
          var startDateValToEdit = new Date(
            Moment(bgDetailsData.ValidityFrom).add(1, "days")
          );

          var documentArr = [];

          if (bgDetailsData.AllDocuments.length > 0) {
            var documentData = bgDetailsData.AllDocuments;
            for (let index = 0; index < documentData.length; index++) {
              const element = {};
              var UploadedOn = Moment(documentData[index].UploadedOn).format(
                "DD-MMM-YYYY HH:mm"
              );
              element.SelectionID = documentData[index].SelectionID;
              element.DocumentID = documentData[index].DocumentID;
              element.FileName = documentData[index].FileName;
              element.Description = documentData[index].Description;
              element.BGDocumentID = documentData[index].BGDocumentID;
              element.UploadedBy = documentData[index].UploadedBy;
              element.DeleteFlag = documentData[index].DeleteFlag;
              element.VirusScanStatus = documentData[index].VirusScanStatus;
              element.SelectionValue = documentData[index].SelectionValue;
              element.UploadedOn = UploadedOn;
              element.ImageType = 0;
              documentArr.push(element);
            }
          }

          this.setState({
            ReqIDEdit: bgDetailsData.ReqID,
            BGTypeEdit: bgDetailsData.BGType,
            BGTypeValueEdit: bgDetailsData.BGTypeValue,
            BGNumEdit: bgDetailsData.BGNum,
            BGDateEdit: BGDate,
            DivisionEdit: bgDetailsData.Division,
            DivisionValueEdit: bgDetailsData.DivisionValue,
            BranchEdit: bgDetailsData.Branch,
            Branch: bgDetailsData.Branch,
            SAPCustEdit: bgDetailsData.SAPCust,
            OrderNumEdit: bgDetailsData.OrderNum,
            IsOrderTenderEdit: bgDetailsData.IsOrderTender,
            OrderDateEdit: OrderDate,
            OrderValueEdit: bgDetailsData.OrderValue,
            IssuingBankEdit: bgDetailsData.IssuingBank,
            PreferredBankEdit: bgDetailsData.PreferredBank,
            IssuingBankValueEdit: bgDetailsData.IssuingBankValue,
            PreferredBankValueEdit: bgDetailsData.PreferredBankValue,
            BusyCustomer: bgDetailsData.BusyCustomer,
            BGValueEdit: bgDetailsData.BGValue,
            // StampPaperValue: bgDetailsData.StampPaperValue,
            BGValueReqEdit: bgDetailsData.BGValue,
            BGValueActualEdit: bgDetailsData.BGValueActual,
            ValidityFromEdit: ValidityFrom,
            ValidityToEdit: ValidityTo,
            ClaimPeriodEdit: ClaimPeriod,
            ReqStatusEdit: bgDetailsData.ReqStatus,
            DischargeOfLiabilityByBankEdit: DischargeOfLiabilityByBank,
            NotesEdit: bgDetailsData.Notes,
            ReqStatus: bgDetailsData.ReqStatus,
            InitialReqStatus: bgDetailsData.ReqStatus,
            DateOfApplication: DateOfApplication,
            ApplicationEdit: DateOfApplication,
            ReqStatusValue: bgDetailsData.ReqStatusValue,
            CustomerHandOverDate: CustomerHandOverDate,
            DateOfReturnByCustomer: DateOfReturnByCustomer,
            OrderDateDisplay: OrderDateDisplay,
            ReqDate: ReqDate,
            SurrenderEdit: SurrenderEdit,
            lasttdateValidity: lasttdateValidity,
            startDateValToEdit: startDateValToEdit,
            StartCustomerHandOverDate: StartCustomerHandOverDate,
            LatestReqstorNote: bgDetailsData.LatestReqstorNote,
            documentArr: documentArr,
            // expanded:[],
            lodingImagData: false,
          });
        } else {
          console.log("errorrrrrrrrrr");
          this.setState({
            lodingImagData: false,
          });
        }
      };
      editBgRequest();
    } else {
      this.setState({
        Branch: "",
        SAPCustid: "",
        OrderNum: "",
        Code: "",
        OrderDate: "",
        OrderValue: "",
        BGValueReq: "",
        PreferredBank: "",
        ValidityFrom: "",
        ValidityTo: "",
        ClaimPeriod: "",
        BGType: "",
        Notes: "",
        // StampPaperValue: "",
        ImageType: "",
        documentArr: [],
        lodingImagData: false,
      });
    }
    var imageCount = 0;

    this.setState({
      showData: true,
      showAdd: showAdd,
      openStatus: event,
      imageLoop: imageLoop,
      imageCount: imageCount,
    });
  };

  render() {
    const addUserLogo = require("../../../assets/images/plus.png");
    const loadingImg = require("../../../assets/images/Hourglass.gif");
    const imageLoop = this.state.imageLoop;
    const uploadLogoImage = this.state.profileImage;
    var documentArr = this.state.documentArr;

    const { SapCustIdArr, SAPCustid, SAPCustEdit, bgDetailsDataCustomer } =
      this.state;

    console.log("childReqID", this.state.childReqID);

    const options = SapCustIdArr?.map((item) => ({
      value: item.key,
      label: item.value,
    }));

    const selectedOption = options?.find(
      (option) => option.value === SAPCustid
    );

    const selectedOptionEdit = options?.find(
      (option) => option.value === SAPCustEdit
    );

    // console.log("selectedOptionEdit", selectedOptionEdit);

    var BgTypeIdArr = this.state.BgTypeIdArr;
    var BankIdArr = this.state.BankIdArr;
    var BankIssueIdArr = this.state.BankIssueIdArr;
    var DivisionIdArr = this.state.DivisionIdArr;
    // var SapCustIdArr = this.state.SapCustIdArr;
    var columns = "";
    var listStatusId = this.state.listStatusId;
    var permissionArr = this.state.permissionArr;
    var listBranch = this.state.listBranch;
    var selectionImage = this.state.selectionImage;
    if (this.state.selectedStatus === "Request") {
      columns = [
        {
          dataField: "ReqID",
          text: "Req #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "sch-headerName reqHeader cursorPoint",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "DivisionValue",
          text: "BU/Branch",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          formatter: (cellContent, row) => {
            var listBranchData = this.state.listBranchData;
            const filteredData = listBranchData.filter((obj) => {
              return obj.key === parseInt(row.Branch);
            });
            if (filteredData.length > 0) {
              return (
                <span>{row.DivisionValue + " / " + filteredData[0].value}</span>
              );
            } else {
              return <span>{row.DivisionValue}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "SAPCust",
          text: "Client Name (SAP/Busy)",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName ClientHeader",
          formatter: (cellContent, row) => {
            if (row.BusyCustomer !== "") {
              return <span>{row.SAPCust + " / " + row.BusyCustomer}</span>;
            } else {
              return <span>{row.SAPCust}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderNum",
          text: "Order/Tender #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeader",
          formatter: (cellContent, row) => {
            return row.OrderNum;
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderDate",
          text: "Order/Tender Date",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeader",
          formatter: (cellContent, row) => {
            if (
              row.OrderDate !== "9999-12-31" &&
              row.OrderDate !== "1900-01-01"
            )
              return Moment(row.OrderDate).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderValue",
          text: "Order/Tender Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGValue",
          text: "BG Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "PreferredBankValue",
          text: "Preferred Bank",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGTypeValue",
          text: "Type",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint typeHeader sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ValidityTo",
          text: "Validity",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint DateClaimHeader sch-headerName",
          formatter: (cellContent, row) => {
            return Moment(row.ValidityTo).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ClaimPeriod",
          text: "Claim Period",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint DateClaimHeader sch-headerName",
          formatter: (cellContent, row) => {
            if (
              row.ClaimPeriod !== "9999-12-31" &&
              row.ClaimPeriod !== "1900-01-01"
            )
              return Moment(row.ClaimPeriod).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "Notes",
          text: "Latest Notes",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName cursorPoint",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ReqStatusValue",
          text: "Status",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "cursorPoint removePadding",
          headerClasses: "cursorPoint typeHeader sch-headerName cursorPoint",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
      ];
    } else if (this.state.selectedStatus === "BG") {
      columns = [
        {
          dataField: "ReqID",
          text: "Req #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "cursorPoint removePadding",
          headerClasses: "sch-headerName reqHeader cursorPoint",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "DivisionValue",
          text: "BU/Branch",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          formatter: (cellContent, row) => {
            var listBranchData = this.state.listBranchData;
            const filteredData = listBranchData?.filter((obj) => {
              return obj.key === parseInt(row.Branch);
            });
            if (filteredData.length > 0) {
              return (
                <span>{row.DivisionValue + " / " + filteredData[0].value}</span>
              );
            } else {
              return <span>{row.DivisionValue}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "SAPCust",
          text: "Client Name (SAP/Busy)",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName ClientHeader",
          formatter: (cellContent, row) => {
            if (row.BusyCustomer !== "") {
              return <span>{row.SAPCust + " / " + row.BusyCustomer}</span>;
            } else {
              return <span>{row.SAPCust}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderNum",
          text: "Order/Tender #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeaderBG",
          formatter: (cellContent, row) => {
            return row.OrderNum;
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderDate",
          text: "Order/Tender Date",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeaderBG",
          formatter: (cellContent, row) => {
            if (
              row.OrderDate !== "9999-12-31" &&
              row.OrderDate !== "1900-01-01"
            )
              return Moment(row.OrderDate).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderValue",
          text: "Order/Tender Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "IssuingBankValue",
          text: "Issuing Bank",
          filter: textFilter({
            className: "filter_class_comp",
            //  defaultValue: this?.state?.BankName,
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGTypeValue",
          text: "Type",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint typeHeader sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGNum",
          text: "BG #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGDate",
          text: "BG Date",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint DateHeader sch-headerName",
          formatter: (cellContent, row) => {
            if (row.BGDate !== "9999-12-31" && row.BGDate !== "1900-01-01")
              return Moment(row.BGDate).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGValue",
          text: "BG Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ValidityTo",
          text: "Validity",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint DateClaimHeaderBg sch-headerName",
          formatter: (cellContent, row) => {
            return Moment(row.ValidityTo).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ClaimPeriod",
          text: "Claim Period",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint DateClaimHeaderBg sch-headerName",
          formatter: (cellContent, row) => {
            if (
              row.ClaimPeriod !== "9999-12-31" &&
              row.ClaimPeriod !== "1900-01-01"
            )
              return Moment(row.ClaimPeriod).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "Notes",
          text: "Latest Notes",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName cursorPoint",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ReqStatusValue",
          text: "Status",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "cursorPoint removePadding",
          headerClasses: "cursorPoint typeHeader sch-headerName cursorPoint",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
      ];
    } else if (this.state.selectedStatus === "Cancelled") {
      columns = [
        {
          dataField: "ReqID",
          text: "Req #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "cursorPoint removePadding",
          headerClasses: "cursorPoint sch-headerName reqHeader",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "DivisionValue",
          text: "BU/Branch",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          formatter: (cellContent, row) => {
            var listBranchData = this.state.listBranchData;
            const filteredData = listBranchData.filter((obj) => {
              return obj.key === parseInt(row.Branch);
            });
            if (filteredData.length > 0) {
              return (
                <span>{row.DivisionValue + " / " + filteredData[0].value}</span>
              );
            } else {
              return <span>{row.DivisionValue}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "SAPCust",
          text: "Client Name (SAP/Busy)",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName ClientHeader",
          formatter: (cellContent, row) => {
            if (row.BusyCustomer !== "") {
              return <span>{row.SAPCust + " / " + row.BusyCustomer}</span>;
            } else {
              return <span>{row.SAPCust}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderNum",
          text: "Order/Tender #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeader",
          formatter: (cellContent, row) => {
            return row.OrderNum;
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderDate",
          text: "Order/Tender Date",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeader",
          formatter: (cellContent, row) => {
            if (
              row.OrderDate !== "9999-12-31" &&
              row.OrderDate !== "1900-01-01"
            )
              return Moment(row.OrderDate).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderValue",
          text: "Order/Tender Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGValue",
          text: "BG Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "PreferredBankValue",
          text: "Preferred Bank",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGTypeValue",
          text: "Type",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName typeHeader",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ReqStatusValue",
          text: "Status",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
      ];
    } else {
      columns = [
        {
          dataField: "ReqID",
          text: "Req #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "cursorPoint removePadding",
          headerClasses: "cursorPoint sch-headerName reqHeader",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "DivisionValue",
          text: "BU/Branch",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          formatter: (cellContent, row) => {
            var listBranchData = this.state.listBranchData;
            const filteredData = listBranchData.filter((obj) => {
              return obj.key === parseInt(row.Branch);
            });
            if (filteredData.length > 0) {
              return (
                <span>{row.DivisionValue + " / " + filteredData[0].value}</span>
              );
            } else {
              return <span>{row.DivisionValue}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "SAPCust",
          text: "Client Name (SAP/Busy)",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName ClientHeader",
          formatter: (cellContent, row) => {
            if (row.BusyCustomer !== "") {
              return <span>{row.SAPCust + " / " + row.BusyCustomer}</span>;
            } else {
              return <span>{row.SAPCust}</span>;
            }
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderNum",
          text: "Order/Tender #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeader",
          formatter: (cellContent, row) => {
            return row.OrderNum;
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderDate",
          text: "Order/Tender Date",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName tenderHeader",
          formatter: (cellContent, row) => {
            if (
              row.OrderDate !== "9999-12-31" &&
              row.OrderDate !== "1900-01-01"
            )
              return Moment(row.OrderDate).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "OrderValue",
          text: "Order/Tender Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "IssuingBankValue",
          text: "Issuing Bank",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGTypeValue",
          text: "Type",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName typeHeader",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGNum",
          text: "BG #",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGDate",
          text: "BG Date",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          formatter: (cellContent, row) => {
            if (row.BGDate !== "9999-12-31" && row.BGDate !== "1900-01-01")
              return Moment(row.BGDate).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "BGValue",
          text: "BG Value",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          // formatter:(cellContent, row)=>{
          //   return <span>{row.OrderValue+' / '+row.BGValue}</span>
          // },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "SurrenderToBank",
          text: "Surrender",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint sch-headerName",
          formatter: (cellContent, row) => {
            if (
              row.SurrenderToBank !== "9999-12-31" &&
              row.SurrenderToBank !== "1900-01-01"
            )
              return Moment(row.SurrenderToBank).format("DD-MMM-YYYY");
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "DischargeOfLiabilityByBank",
          text: "Discharge Of Liability",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "cursorPoint DateClaimHeader sch-headerName",
          formatter: (cellContent, row) => {
            if (
              row.DischargeOfLiabilityByBank !== "9999-12-31" &&
              row.DischargeOfLiabilityByBank !== "1900-01-01"
            )
              return Moment(row.DischargeOfLiabilityByBank).format(
                "DD-MMM-YYYY"
              );
          },
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
        {
          dataField: "ReqStatusValue",
          text: "Status",
          filter: textFilter({
            className: "filter_class_comp",
            placeholder: "Search",
          }),
          sort: true,
          classes: "removePadding cursorPoint",
          headerClasses: "sch-headerName",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.Code === 20) {
                this.handleShow("Approval", row);
              } else {
                this.handleShow("Requester", row);
              }
            },
          },
        },
      ];
    }

    const rowStyle = (row, rowIndex) => {
      if (row.ChildReqID && this.state.selectedStatus === "BG") {
        return {
          backgroundColor: "#ACE1AF", // Customize the background color
        };
      }
      return {};
    };

    var bgdetails = this.state.bgdetails;
    const expandRow = {
      className: "expanding-foo",
      parentClassName: "parent-expand-foo",
      showExpandColumn: true,
      expandByColumnOnly: true,
      renderer: (row) => (
        <div className="jobLogData">
          {this.state.BGLogs[row.ReqID] !== "" &&
          this.state.BGLogs[row.ReqID] !== null &&
          this.state.BGLogs[row.ReqID] !== undefined ? (
            this.state.BGLogs[row.ReqID].map((ChangeInfos, indexId) =>
              indexId > 8 ? (
                <span key={indexId} className="jobLogLink">
                  {indexId + 1 + ")"}&nbsp;&nbsp;
                  {ChangeInfos.ModifiedDate_ModifiedBy_Status_Notes}
                </span>
              ) : (
                <span key={indexId} className="jobLogLink">
                  {indexId + 1 + ")"}&nbsp;&nbsp;&nbsp;&nbsp;
                  {ChangeInfos.ModifiedDate_ModifiedBy_Status_Notes}
                </span>
              )
            )
          ) : (
            <p className="loadingLog">
              <Spinner animation="grow" variant="primary" />
            </p>
          )}
        </div>
      ),

      // expandByColumnOnly: true,
      onExpand: this.handleOnExpand,
    };
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-all">
            <div className="filterbtn-sche">
              <Dropdown onSelect={this.handleDropdown}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size DropClassBtn"
                  id="dropdown-basic"
                >
                  {this.state.selectedStatus}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listStatusId !== ""
                    ? listStatusId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn" style={{ position: "relative" }}>
              <Button
                variant="primary"
                className="font_size FetchClassBtn"
                onClick={() => this.handleInputFetch()}
              >
                Fetch
              </Button>
              {this.state.selectedStatus === "BG" && (
                <span className="pickbtn-note">
                  <IoIosInformationCircle
                    size={20}
                    onMouseEnter={this.handleMouseEnterFetch}
                    onMouseLeave={this.handleMouseLeaveFetch}
                  />
                </span>
              )}
              {this.state.showTooltipBox && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    width: "200px",
                    left: "90%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    marginTop: "10px",
                    zIndex: 9999,
                  }}
                >
                  The requests in green colour are for the renewed BGs
                </div>
              )}
            </div>
            {this.state.editBtn === true ? (
              <div className="submiteditbtnsche">
                <img
                  src={addUserLogo}
                  alt="logo"
                  className="logo-add-user cursorPoint"
                  title="Request"
                  onClick={() => {
                    this.handleShow("Request");
                  }}
                />
              </div>
            ) : (
              ""
            )}
            <div
              className={
                this.state.editBtn === true
                  ? "submiteditbtnscheother"
                  : "submiteditbtnscheotherBG"
              }
            >
              <Link
                to="/home"
                title="Reset"
                onClick={this.handleReset}
                className="resetLogo"
              >
                <GrPowerReset className="logoReset" />
              </Link>
            </div>
          </div>
        </div>

        <div className="table-container-all">
          <BootstrapTable
            classes="tabledata-all"
            keyField="ReqID"
            id="tabledata"
            data={bgdetails}
            columns={columns}
            rowStyle={rowStyle}
            expandRow={expandRow}
            // overlay={overlayFactory({
            //   spinner: true,
            // })}
            filter={filterFactory({ className: "custom_filter_class" })}
            loading={this.state.loading}
            noDataIndication={this.state.loadingData}
          />
        </div>

        {this.state.showRenewModal ? (
          <Offcanvas
            className="useroff-sch"
            show={this.state.showData}
            scroll={this.state.scroll}
            name={this.state.name}
            backdrop={this.state.backdrop}
            placement={this.state.placement}
            onHide={this.handleClose}
          >
            <Offcanvas.Header className="popup_header">
              {/* <button type="button" class="btn-close closeBtn" aria-label="Close"></button> */}
              <Offcanvas.Title className="header_title">
                <span className="title_contant">
                  {this.state.openStatus === "Acceptance" ||
                  this.state.openStatus === "Approval" ||
                  this.state.openStatus === "Requester" ||
                  this.state.openStatus === "BG Details" ||
                  this.state.openStatus === "BG Closure" ? (
                    <span>
                      <span> Req # : {this.state.ReqIDEdit} / Renew / </span>{" "}
                      Status : {this.state.ReqStatusValue}
                    </span>
                  ) : (
                    <span>{this.state.openStatus}</span>
                  )}
                </span>
              </Offcanvas.Title>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={this.handleClose}
              >
                <AiOutlineClose className="closeBtn" />
              </button>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="container">
                <div className="rowUser justify-content-center">
                  <div className="col-md-12">
                    {this.state.openStatus === "Requester" ? (
                      <form
                        className="pr-5 mb-5 formUser"
                        onSubmit={this.handleRenewBgRequest}
                      >
                        <div className="row">
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Business Unit *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="DivisionEdit"
                                disabled={
                                  this.state.StatusCode === 10 ? false : true
                                }
                                onChange={this.handleDataChangeOtherDivision}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.DivisionEdit}
                              >
                                <option value="">Select Business Unit</option>
                                {DivisionIdArr !== ""
                                  ? DivisionIdArr?.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Branch *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="BranchEdit"
                                disabled={
                                  this.state.StatusCode === 10 ? false : true
                                }
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.BranchEdit}
                              >
                                <option value="">Select Branch</option>
                                {listBranch !== ""
                                  ? listBranch.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-6 form-group input-user">
                            {/* <FloatingLabel
                            controlId="floatingSelect"
                            className="lableWidth"
                            label="SAP Cust Name"
                          >
                            <Form.Select
                              aria-label="Division"
                              name="SAPCustEdit"
                              disabled={
                                this.state.StatusCode === 10 ? false : true
                              }
                              onChange={this.handleDataChangeOther}
                              required={true}
                              className="edit_job form__field_select selectAsealign"
                              value={this.state.SAPCustEdit}
                            >
                              {SapCustIdArr !== ""
                                ? SapCustIdArr?.map((item, indexdata) => {
                                    return (
                                      <option key={indexdata} value={item.key}>
                                        {item.value}
                                      </option>
                                    );
                                  })
                                : ""}
                            </Form.Select>
                          </FloatingLabel> */}
                            <Select
                              onChange={this.handleDataChangeDropEdit}
                              value={selectedOptionEdit}
                              options={options}
                              className="font_size edit_job"
                              placeholder="Select SAP Cust Name"
                              isClearable
                              isDisabled={this.state.StatusCode !== 10}
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Type *"
                            >
                              <Form.Select
                                aria-label="Type"
                                name="IsOrderTenderEdit"
                                disabled={true}
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.IsOrderTenderEdit}
                              >
                                <option value="">Select Type</option>
                                <option value={false}>Order</option>
                                <option value={true}>Tender</option>
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender # *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="text"
                                maxLength={50}
                                disabled={
                                  this.state.StatusCode === 10 ? false : true
                                }
                                required={true}
                                name="OrderNumEdit"
                                onChange={this.handleDataChangeOther}
                                value={this.state.OrderNumEdit}
                                placeholder="Order #"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user DateAlign">
                            <label
                              className={
                                this.state.StatusCode === 10
                                  ? "moveDataStart"
                                  : "moveDataStart labelClass"
                              }
                            >
                              Order/Tender Date *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartEdit}
                              selected={this.state.OrderDateEdit}
                              dateFormat="dd-MMM-yyyy"
                              // minDate={this.state.startDateOtData}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Order/Tender Date *"
                              className="form-control"
                              disabled={
                                this.state.StatusCode === 10 ? false : true
                              }
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="number"
                                disabled={
                                  this.state.StatusCode === 10 ? false : true
                                }
                                required={true}
                                name="OrderValueEdit"
                                onChange={this.handleNumberChange}
                                value={this.state.OrderValueEdit}
                                placeholder="Order Value"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="BG Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="number"
                                disabled={
                                  this.state.StatusCode >= 50 ? true : false
                                }
                                required={true}
                                name="BGValueReqEdit"
                                onChange={this.handleNumberChange}
                                value={this.state.BGValueReqEdit}
                                placeholder="BG Value"
                              />
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6 form-group input-user">
                            <label
                              className={
                                this.state.StatusCode >= 60
                                  ? "moveDataStart labelClass"
                                  : "moveDataStart"
                              }
                            >
                              Validity from *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartValFromEdit}
                              selected={this.state.ValidityFromEdit}
                              dateFormat="dd-MMM-yyyy"
                              // minDate={this.state.OrderDateEdit}
                              minDate={this.state.lasttdateValidity}
                              required
                              placeholderText="Validity from *"
                              className="form-control"
                              disabled={
                                this.state.StatusCode >= 60 ? true : false
                              }
                            />
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <label className={"moveDataStart"}>
                              Renew Validity To *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartValToEdit}
                              selected={this.state.ValidityToEdit}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDateValToEdit}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Validity To *"
                              className="form-control"
                            />
                          </div>
                          {this.state.isError.timeVali !== "" ? (
                            <span className="tool_tip">
                              {this.state.isError.timeVali}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user">
                            <label className={"moveDataStart"}>
                              Renew Claim period *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeEndClaimEdit}
                              selected={this.state.ClaimPeriodEdit}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDateClaimEdit}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Claim period *"
                              className="form-control"
                            />
                            {this.state.isError.timeValiClaim !== "" ? (
                              <span className="tool_tip">
                                {this.state.isError.timeValiClaim}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="BG Type *"
                            >
                              <Form.Select
                                aria-label="Type"
                                name="BGTypeEdit"
                                onChange={this.handleDataChangeOther}
                                disabled={
                                  this.state.StatusCode === 10 ? false : true
                                }
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.BGTypeEdit}
                              >
                                <option value="">Select Type</option>
                                {BgTypeIdArr !== ""
                                  ? BgTypeIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-1">
                          {/* <div className="col-md-6 form-group input-user selectAsealign">
                              <button className='btn btn-primary font_size ' onClick={() => {this.handleShowModal()}}>Document Upload</button>
                             {this.state.imageCount !== 0 ?
                                <span>&nbsp;&nbsp; {this.state.imageCount} document(s) uploaded.</span>
                             :""}
                             
                           </div> */}
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Preferred Bank *"
                            >
                              <Form.Select
                                aria-label="Preferred Bank"
                                name="PreferredBankEdit"
                                disabled={
                                  this.state.StatusCode === 10 ? false : true
                                }
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.PreferredBankEdit}
                              >
                                <option value="">Select Preferred Bank</option>
                                {BankIdArr !== ""
                                  ? BankIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          {/* <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            className="lableWidth"
                            label="Stamp Paper Value *"
                          >
                            <Form.Control
                              className="edit_job_edit form__field"
                              type="number"
                              disabled={
                                this.state.StatusCode === 10 ? false : true
                              }
                              required={true}
                              name="StampPaperValue"
                              onChange={this.handleNumberChange}
                              value={this.state.StampPaperValue}
                              placeholder="Stamp Paper Value"
                            />
                          </FloatingLabel>
                        </div> */}
                          {this.state.StatusCode > 20 &&
                          this.state.ReqStatus !== 150 &&
                          this.state.ReqStatus !== 10 ? (
                            <div className="col-md-6 form-group input-user">
                              <FloatingLabel
                                controlId="floatingSelect"
                                className="lableWidth"
                                label="Busy Customer Name*"
                              >
                                <Form.Control
                                  className="edit_job_edit form__field"
                                  type="text"
                                  required={true}
                                  disabled={
                                    this.state.StatusCode >= 60 ? true : false
                                  }
                                  name="BusyCustomer"
                                  maxLength={25}
                                  onChange={this.handleDataChangeOther}
                                  value={this.state.BusyCustomer}
                                  placeholder="Busy Customer Name"
                                />
                              </FloatingLabel>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="row mt-2">
                          {this.state.ReqStatusValue === "Customer" ? (
                            <div className="col-md-2 form-group input-use mt-3">
                              <button
                                type="submit"
                                // onClick={this.handleRenewBgRequest}
                                disabled={!this.state.renewalFlag}
                                className="btnval btn btn-warning font_size"
                              >
                                Renew
                              </button>
                            </div>
                          ) : null}

                          <div className="col-md-2 form-group input-use mt-3">
                            <button
                              type="button"
                              onClick={this.handleClose}
                              className="btnval btn btn-danger font_size"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                        <div className="row mt-3 ">
                          <span className="DottedClass"></span>
                          <div className="col-md-12 form-group input-user">
                            <Table bordered responsive>
                              <thead>
                                <th className="alginCenter">Document Type</th>
                                <th className="alginCenter">Document Name</th>
                                <th className="alginCenter">Description</th>
                                <th className="alginCenter">Uploaded By/On</th>
                                {/* <th className="alginCenter taskWithPlus">
                                  {this.state.editReq === false ||
                                  permissionArr.length === 0 ? (
                                    ""
                                  ) : (
                                    <span
                                      className="saveBtnUsPl cursorPoint"
                                      onClick={() => {
                                        this.handleShowModal();
                                      }}
                                    >
                                      <FaPlusCircle />
                                    </span>
                                  )}
                                </th> */}
                                <th className="alginCenter"></th>
                              </thead>
                              <tbody>
                                {documentArr.length > 0 ? (
                                  documentArr.map((item, indexdata) => {
                                    return (
                                      <tr key={indexdata}>
                                        <td className="alginCenter">
                                          {item.SelectionValue}
                                        </td>
                                        <td className="alginCenter">
                                          {item.FileName}
                                        </td>
                                        <td className="alginCenter">
                                          {item.Description}
                                        </td>
                                        <td className="alginCenter">
                                          {item.UploadedBy +
                                            " / " +
                                            item.UploadedOn}
                                        </td>
                                        {item.DeleteFlag === true &&
                                        this.state.editReq === true &&
                                        permissionArr.length > 0 ? (
                                          <td className="alginCenter taskWithPlus">
                                            <span
                                              className="saveBtnUsMi cursorPoint"
                                              onClick={() =>
                                                this.handleDataRemoveImage(
                                                  indexdata
                                                )
                                              }
                                            >
                                              <FaMinusCircle />
                                            </span>
                                          </td>
                                        ) : (
                                          <td className="alginCenter taskWithPlus"></td>
                                        )}
                                        <td className="alginCenter cursorPoint">
                                          <span>
                                            <FaDownload
                                              onClick={() => {
                                                if (
                                                  item?.VirusScanStatus === "C"
                                                ) {
                                                  this.handleImageDownload(
                                                    item.FileName,
                                                    item.DocumentID
                                                  );
                                                }
                                              }}
                                              style={{
                                                color:
                                                  item?.VirusScanStatus === "C"
                                                    ? "green"
                                                    : "grey",
                                                cursor:
                                                  item?.VirusScanStatus === "C"
                                                    ? "pointer"
                                                    : "not-allowed",
                                              }}
                                              title={
                                                item?.VirusScanStatus === "C"
                                                  ? "Download"
                                                  : "Download Disabled"
                                              }
                                            />
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td className="alginCenter" colSpan={5}>
                                      No Document Uploaded yet!
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                        <div className="row">
                          <span className="text-danger">
                            Note: The uploaded file will be scanned . A
                            greyed-out download icon {"( "}
                            <span
                              style={{
                                color: "grey",
                              }}
                            >
                              <FaDownload />
                            </span>
                            {" ) "}
                            indicates that the file is infected and cannot be
                            downloaded. A green download icon {"( "}
                            <span
                              style={{
                                color: "green",
                              }}
                            >
                              <FaDownload />
                            </span>
                            {" ) "}
                            indicates that the file is clean and can be safely
                            downloaded.
                          </span>
                        </div>
                      </form>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        ) : (
          <Offcanvas
            className="useroff-sch"
            show={this.state.showData}
            scroll={this.state.scroll}
            name={this.state.name}
            backdrop={this.state.backdrop}
            placement={this.state.placement}
            onHide={this.handleClose}
          >
            <Offcanvas.Header className="popup_header">
              {/* <button type="button" class="btn-close closeBtn" aria-label="Close"></button> */}
              <Offcanvas.Title className="header_title">
                <span className="title_contant">
                  {this.state.openStatus === "Acceptance" ||
                  this.state.openStatus === "Approval" ||
                  this.state.openStatus === "Requester" ||
                  this.state.openStatus === "BG Details" ||
                  this.state.openStatus === "BG Closure" ? (
                    <span>
                      Req # : {this.state.ReqIDEdit}{" "}
                      <span className="headerDatapoint"> / </span> Req Date :{" "}
                      {this.state.OrderDateDisplay}
                      <span className="headerDatapoint"> / </span> Status :{" "}
                      {this.state.ReqStatusValue}
                    </span>
                  ) : (
                    <span>{this.state.openStatus}</span>
                  )}
                </span>
              </Offcanvas.Title>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={this.handleClose}
              >
                <AiOutlineClose className="closeBtn" />
              </button>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="container">
                <div className="rowUser justify-content-center">
                  <div className="col-md-12">
                    {this.state.openStatus === "Request" ? (
                      <form
                        className="pr-5 mb-5 formUser"
                        method="POST"
                        onSubmit={this.handleSubmitRequest}
                      >
                        <div className="row">
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Business Unit *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="Division"
                                onChange={this.handleDataChangeOtherDivision}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.Division}
                              >
                                <option value="">Select Business Unit</option>
                                {DivisionIdArr !== ""
                                  ? DivisionIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Branch *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="Branch"
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.Branch}
                              >
                                <option value="">Select Branch</option>
                                {listBranch !== ""
                                  ? listBranch.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          {/* <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            controlId="floatingSelect"
                            className="lableWidth"
                            label="SAP Cust Name"
                          >
                            <Form.Select
                              aria-label="SAP Cust"
                              name="SAPCustid"
                              onChange={this.handleDataChangeOther}
                              required={true}
                              className="edit_job form__field_select selectAsealign"
                              value={this.state.SAPCustid}
                            >
                              <option value="">Select SAP Cust Name</option>
                              {SapCustIdArr !== ""
                                ? SapCustIdArr.map((item, indexdata) => {
                                    return (
                                      <option key={indexdata} value={item.key}>
                                        {item.value}
                                      </option>
                                    );
                                  })
                                : ""}
                            </Form.Select>
                          </FloatingLabel>
                        </div> */}
                          <div className="col-md-6 form-group input-user">
                            <Select
                              onChange={this.handleDataChangeDrop}
                              value={selectedOption}
                              options={options}
                              className="font_size edit_job select_dropdown_search"
                              placeholder="Select SAP Cust Name"
                              isClearable
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Type *"
                            >
                              <Form.Select
                                aria-label="SAP Cust"
                                name="IsOrderTender"
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.IsOrderTender}
                              >
                                <option value="">Select Type</option>
                                <option value={false}>Order</option>
                                <option value={true}>Tender</option>
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender # *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="text"
                                required={true}
                                name="OrderNum"
                                maxLength="50"
                                onChange={this.handleDataChangeOther}
                                value={this.state.OrderNum}
                                placeholder="Order #"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user DateAlign">
                            <label className="moveDataStart">
                              Order/Tender Date *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStart}
                              selected={this.state.OrderDate}
                              dateFormat="dd-MMM-yyyy"
                              // minDate={this.state.startDateOtData}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Order/Tender Date *"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="number"
                                required={true}
                                name="OrderValue"
                                onChange={this.handleNumberChange}
                                value={this.state.OrderValue}
                                placeholder="Order Value"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="BG Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="number"
                                required={true}
                                name="BGValueReq"
                                onChange={this.handleNumberChange}
                                value={this.state.BGValueReq}
                                placeholder="BG Value"
                              />
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6 form-group input-user">
                            <label className="moveDataStart">
                              Validity from *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartValFrom}
                              selected={this.state.ValidityFrom}
                              dateFormat="dd-MMM-yyyy"
                              // minDate={this.state.startDate}
                              minDate={this.state.lasttdateValidity}
                              required
                              placeholderText="Validity from *"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <label className="moveDataStart">
                              Validity To *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartValTo}
                              selected={this.state.ValidityTo}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDateValTo}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Validity To *"
                              className="form-control"
                            />
                          </div>
                          {this.state.isError.timeVali !== "" ? (
                            <span className="tool_tip">
                              {this.state.isError.timeVali}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user">
                            <label className="moveDataStart">
                              Claim period *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeEndClaim}
                              selected={this.state.ClaimPeriod}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDateClaim}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Claim period *"
                              className="form-control"
                            />
                            {this.state.isError.timeValiClaim !== "" ? (
                              <span className="tool_tip">
                                {this.state.isError.timeValiClaim}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="BG Type *"
                            >
                              <Form.Select
                                aria-label="Type"
                                name="BGType"
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.BGType}
                              >
                                <option value="">Select Type</option>
                                {BgTypeIdArr !== ""
                                  ? BgTypeIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-1">
                          {/* <div className="col-md-6 form-group input-user selectAsealign">
                              <button className='btn btn-primary font_size ' onClick={() => {this.handleShowModal()}}>Document Upload</button>
                             {this.state.imageCount !== 0 ?
                                <span>&nbsp;&nbsp; {this.state.imageCount} document(s) uploaded.</span>
                             :""}
                             
                           </div> */}
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Preferred Bank *"
                            >
                              <Form.Select
                                aria-label="Preferred Bank"
                                name="PreferredBank"
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.PreferredBank}
                              >
                                <option value="">Select Preferred Bank</option>
                                {BankIdArr !== ""
                                  ? BankIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          {/* <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            className="lableWidth"
                            label="Stamp Paper Value *"
                          >
                            <Form.Control
                              className="edit_job_edit form__field"
                              type="number"
                              // disabled={
                              //   this.state.StatusCode >= 50 ? true : false
                              // }
                              max={5}
                              required={true}
                              name="StampPaperValue"
                              onChange={this.handleNumberChange}
                              value={this.state.StampPaperValue}
                              placeholder="Stamp Paper Value"
                            />
                          </FloatingLabel>
                        </div> */}
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-12 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Notes "
                            >
                              <Form.Control
                                className="edit_job_edit form__field "
                                type="text"
                                name="Notes"
                                maxLength={255}
                                onChange={this.handleDataChangeOther}
                                value={this.state.duration}
                                placeholder="Notes"
                              />
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-4 form-group input-user">
                            {/* <FloatingLabel controlId="floatingSelect" className="lableWidth" label="Action *">
                                <Form.Select aria-label="Action" name="requestStatus" onChange={this.handleDataChangeOther} required={true} className="edit_job form__field_select selectAsealign" value={this.state.requestStatus}>
                                  <option value='10'>Save</option>
                                  <option value='20'>Req Approval</option>
                                </Form.Select>
                              </FloatingLabel> */}
                          </div>
                          <div className="col-md-3 form-group input-user mt-3">
                            <button
                              type="submit"
                              disabled={SAPCustid === "" || null}
                              className="btnval btn btn-success font_size"
                            >
                              Save
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-use mt-3">
                            <button
                              type="button"
                              onClick={this.handleClose}
                              className="btnval btn btn-danger font_size"
                            >
                              Cancel
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user"></div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12 form-group input-user">
                            <Table bordered responsive>
                              <thead>
                                <th className="alginCenter">Document Type</th>
                                <th className="alginCenter">Document Name</th>
                                <th className="alginCenter">Description</th>
                                <th className="alginCenter">Uploaded By/On</th>
                                <th className="alginCenter taskWithPlus">
                                  <span
                                    className="saveBtnUsPl cursorPoint"
                                    onClick={() => {
                                      this.handleShowModal();
                                    }}
                                  >
                                    <FaPlusCircle />
                                  </span>
                                </th>
                                <th className="alginCenter"></th>
                              </thead>
                              <tbody>
                                {documentArr.length > 0 ? (
                                  documentArr.map((item, indexdata) => {
                                    return (
                                      <tr key={indexdata}>
                                        <td className="alginCenter">
                                          {item.SelectionValue}
                                        </td>
                                        <td className="alginCenter">
                                          {item.FileName}
                                        </td>
                                        <td className="alginCenter">
                                          {item.Description}
                                        </td>
                                        <td className="alginCenter">
                                          {item.UploadedBy +
                                            " / " +
                                            item.UploadedOn}
                                        </td>
                                        <td className="alginCenter taskWithPlus">
                                          <span
                                            className="saveBtnUsMi cursorPoint"
                                            onClick={() =>
                                              this.handleDataRemoveImage(
                                                indexdata
                                              )
                                            }
                                          >
                                            <FaMinusCircle />
                                          </span>
                                        </td>
                                        {/* {item.DeleteFlag === true ?
                                        <td className='alginCenter cursorPoint'><FaDownload/></td>
                                      :""} */}
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td className="alginCenter" colSpan={5}>
                                      No Document Uploaded yet!
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </form>
                    ) : (
                      ""
                    )}
                    {this.state.openStatus === "Requester" ? (
                      <form
                        className="pr-5 mb-5 formUser"
                        method="POST"
                        onSubmit={this.handleSubmitRequestEdit}
                      >
                        <div className="row">
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Business Unit *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="DivisionEdit"
                                disabled={
                                  this.state.StatusCode === 10 &&
                                  this.state.parentReqID === null
                                    ? false
                                    : true
                                }
                                onChange={this.handleDataChangeOtherDivision}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.DivisionEdit}
                              >
                                <option value="">Select Business Unit</option>
                                {DivisionIdArr !== ""
                                  ? DivisionIdArr?.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Branch *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="BranchEdit"
                                disabled={
                                  this.state.StatusCode === 10 &&
                                  this.state.parentReqID === null
                                    ? false
                                    : true
                                }
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.BranchEdit}
                              >
                                <option value="">Select Branch</option>
                                {listBranch !== ""
                                  ? listBranch.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-6 form-group input-user">
                            {/* <FloatingLabel
                            controlId="floatingSelect"
                            className="lableWidth"
                            label="SAP Cust Name"
                          >
                            <Form.Select
                              aria-label="Division"
                              name="SAPCustEdit"
                              disabled={
                                this.state.StatusCode === 10 ? false : true
                              }
                              onChange={this.handleDataChangeOther}
                              required={true}
                              className="edit_job form__field_select selectAsealign"
                              value={this.state.SAPCustEdit}
                            >
                              {SapCustIdArr !== ""
                                ? SapCustIdArr?.map((item, indexdata) => {
                                    return (
                                      <option key={indexdata} value={item.key}>
                                        {item.value}
                                      </option>
                                    );
                                  })
                                : ""}
                            </Form.Select>
                          </FloatingLabel> */}
                            <Select
                              onChange={this.handleDataChangeDropEdit}
                              value={selectedOptionEdit}
                              options={options}
                              className="font_size edit_job"
                              placeholder="Select SAP Cust Name"
                              isClearable
                              isDisabled={
                                this.state.StatusCode !== 10 ||
                                this.state.parentReqID !== null
                              }
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Type *"
                            >
                              <Form.Select
                                aria-label="Type"
                                name="IsOrderTenderEdit"
                                disabled={true}
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.IsOrderTenderEdit}
                              >
                                <option value="">Select Type</option>
                                <option value={false}>Order</option>
                                <option value={true}>Tender</option>
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender # *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="text"
                                maxLength={50}
                                disabled={
                                  this.state.StatusCode === 10 &&
                                  this.state.parentReqID === null
                                    ? false
                                    : true
                                }
                                required={true}
                                name="OrderNumEdit"
                                onChange={this.handleDataChangeOther}
                                value={this.state.OrderNumEdit}
                                placeholder="Order #"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user DateAlign">
                            <label
                              className={
                                this.state.StatusCode === 10
                                  ? "moveDataStart"
                                  : "moveDataStart labelClass"
                              }
                            >
                              Order/Tender Date *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartEdit}
                              selected={this.state.OrderDateEdit}
                              dateFormat="dd-MMM-yyyy"
                              // minDate={this.state.startDateOtData}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Order/Tender Date *"
                              className="form-control"
                              disabled={
                                this.state.StatusCode === 10 &&
                                this.state.parentReqID === null
                                  ? false
                                  : true
                              }
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="number"
                                disabled={
                                  this.state.StatusCode === 10 &&
                                  this.state.parentReqID === null
                                    ? false
                                    : true
                                }
                                required={true}
                                name="OrderValueEdit"
                                onChange={this.handleNumberChange}
                                value={this.state.OrderValueEdit}
                                placeholder="Order Value"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="BG Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                type="number"
                                disabled={
                                  this.state.StatusCode >= 50 ||
                                  this.state.parentReqID !== null
                                    ? true
                                    : false
                                }
                                required={true}
                                name="BGValueReqEdit"
                                onChange={this.handleNumberChange}
                                value={this.state.BGValueReqEdit}
                                placeholder="BG Value"
                              />
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6 form-group input-user">
                            <label
                              className={
                                this.state.StatusCode >= 60
                                  ? "moveDataStart labelClass"
                                  : "moveDataStart"
                              }
                            >
                              Validity from *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartValFromEdit}
                              selected={this.state.ValidityFromEdit}
                              dateFormat="dd-MMM-yyyy"
                              // minDate={this.state.OrderDateEdit}
                              minDate={this.state.lasttdateValidity}
                              required
                              placeholderText="Validity from *"
                              className="form-control"
                              disabled={
                                this.state.StatusCode >= 60 ||
                                this.state.parentReqID !== null
                                  ? true
                                  : false
                              }
                            />
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <label
                              className={
                                this.state.StatusCode >= 60
                                  ? "moveDataStart labelClass"
                                  : "moveDataStart"
                              }
                            >
                              Validity To *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStartValToEdit}
                              selected={this.state.ValidityToEdit}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDateValToEdit}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Validity To *"
                              className="form-control"
                              disabled={
                                this.state.StatusCode >= 60 ? true : false
                              }
                            />
                          </div>
                          {this.state.isError.timeVali !== "" ? (
                            <span className="tool_tip">
                              {this.state.isError.timeVali}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user">
                            <label
                              className={
                                this.state.StatusCode >= 60
                                  ? "moveDataStart labelClass"
                                  : "moveDataStart"
                              }
                            >
                              Claim period *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeEndClaimEdit}
                              selected={this.state.ClaimPeriodEdit}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDateClaimEdit}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Claim period *"
                              className="form-control"
                              disabled={
                                this.state.StatusCode >= 60 ? true : false
                              }
                            />
                            {this.state.isError.timeValiClaim !== "" ? (
                              <span className="tool_tip">
                                {this.state.isError.timeValiClaim}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="BG Type *"
                            >
                              <Form.Select
                                aria-label="Type"
                                name="BGTypeEdit"
                                onChange={this.handleDataChangeOther}
                                disabled={
                                  this.state.StatusCode === 10 &&
                                  this.state.parentReqID === null
                                    ? false
                                    : true
                                }
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.BGTypeEdit}
                              >
                                <option value="">Select Type</option>
                                {BgTypeIdArr !== ""
                                  ? BgTypeIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-1">
                          {/* <div className="col-md-6 form-group input-user selectAsealign">
                              <button className='btn btn-primary font_size ' onClick={() => {this.handleShowModal()}}>Document Upload</button>
                             {this.state.imageCount !== 0 ?
                                <span>&nbsp;&nbsp; {this.state.imageCount} document(s) uploaded.</span>
                             :""}
                             
                           </div> */}
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Preferred Bank *"
                            >
                              <Form.Select
                                aria-label="Preferred Bank"
                                name="PreferredBankEdit"
                                disabled={
                                  this.state.StatusCode === 10 &&
                                  this.state.parentReqID === null
                                    ? false
                                    : true
                                }
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.PreferredBankEdit}
                              >
                                <option value="">Select Preferred Bank</option>
                                {BankIdArr !== ""
                                  ? BankIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          {/* <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            className="lableWidth"
                            label="Stamp Paper Value *"
                          >
                            <Form.Control
                              className="edit_job_edit form__field"
                              type="number"
                              disabled={
                                this.state.StatusCode === 10 ? false : true
                              }
                              required={true}
                              name="StampPaperValue"
                              onChange={this.handleNumberChange}
                              value={this.state.StampPaperValue}
                              placeholder="Stamp Paper Value"
                            />
                          </FloatingLabel>
                        </div> */}
                          {this.state.StatusCode > 20 &&
                          this.state.ReqStatus !== 150 &&
                          this.state.ReqStatus !== 10 ? (
                            <div className="col-md-6 form-group input-user">
                              <FloatingLabel
                                controlId="floatingSelect"
                                className="lableWidth"
                                label="Busy Customer Name*"
                              >
                                <Form.Control
                                  className="edit_job_edit form__field"
                                  type="text"
                                  required={true}
                                  disabled={
                                    this.state.StatusCode >= 60 ||
                                    this.state.parentReqID !== null
                                      ? true
                                      : false
                                  }
                                  name="BusyCustomer"
                                  maxLength={25}
                                  onChange={this.handleDataChangeOther}
                                  value={this.state.BusyCustomer}
                                  placeholder="Busy Customer Name"
                                />
                              </FloatingLabel>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {this.state.ReqStatus === "50" ||
                        this.state.ReqStatus === 50 ||
                        (this.state.ReqStatus > 40 &&
                          this.state.ReqStatus !== 150) ? (
                          <div className="row mt-1 ">
                            <span className="DottedClass"></span>
                            {/* <div className="col-md-6 form-group input-user mt-3">
                              <button className='btn btn-primary font_size ' onClick={() => {this.handleShowModal()}}>Document Upload</button>
                              <span>&nbsp;&nbsp; 2 document(s) uploaded.</span>
                           </div> */}
                            <div className="col-md-6 form-group input-user DateAlign">
                              <label
                                className={
                                  this.state.StatusCode >= 60
                                    ? "moveDataStart labelClass"
                                    : "moveDataStart"
                                }
                              >
                                Date of Application *
                              </label>
                              <DatePicker
                                onChange={this.handleChangeApplication}
                                selected={this.state.ApplicationEdit}
                                dateFormat="dd-MMM-yyyy"
                                minDate={this.state.ReqDate}
                                maxDate={this.state.lasttdatemax}
                                required
                                placeholderText="Date of Application *"
                                className="form-control"
                                disabled={this.state.StatusCode >= 60}
                              />
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.StatusCode > 40 &&
                        this.state.ReqStatus > 40 &&
                        this.state.ReqStatus !== 150 ? (
                          <span>
                            <span className="DottedClass"></span>
                            <div className="row mt-1 ">
                              <div className="col-md-6 form-group input-user">
                                <FloatingLabel
                                  className="lableWidth"
                                  label="BG # *"
                                >
                                  <Form.Control
                                    className="edit_job_edit form__field"
                                    type="text"
                                    maxLength={25}
                                    disabled={
                                      this.state.StatusCode >= 60 ||
                                      this.state.parentReqID !== null
                                        ? true
                                        : false
                                    }
                                    required={true}
                                    name="BGNumEdit"
                                    onChange={this.handleDataChangeOther}
                                    value={this.state.BGNumEdit}
                                    placeholder="Finance Notes"
                                  />
                                </FloatingLabel>
                              </div>
                              {this.state.parentReqID !== null &&
                              this.state.StatusCode === 40 ? null : (
                                <div className="col-md-6 form-group input-user">
                                  <label
                                    className={
                                      this.state.StatusCode >= 60
                                        ? "moveDataStart labelClass"
                                        : "moveDataStart"
                                    }
                                  >
                                    BG Date *
                                  </label>
                                  <DatePicker
                                    onChange={this.handleChangeBGDateEdit}
                                    selected={this.state.BGDateEdit}
                                    dateFormat="dd-MMM-yyyy"
                                    // minDate={this.state.startDateBg}
                                    minDate={
                                      new Date(
                                        new Date(
                                          this.state.ApplicationEdit
                                        ).setDate(
                                          new Date(
                                            this.state.ApplicationEdit
                                          ).getDate() + 0
                                        )
                                      )
                                    }
                                    maxDate={this.state.lasttdatemax}
                                    required
                                    placeholderText="BG Date *"
                                    className="form-control"
                                    disabled={this.state.StatusCode >= 60}
                                  />
                                </div>
                              )}
                            </div>
                            <div className="row mt-1">
                              <div className="col-md-6 form-group input-user">
                                <FloatingLabel
                                  className="lableWidth"
                                  label="Issuing Bank *"
                                >
                                  <Form.Select
                                    aria-label="Issuing Bank"
                                    name="IssuingBankEdit"
                                    disabled={
                                      this.state.StatusCode >= 60 ||
                                      this.state.parentReqID !== null
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleDataChangeOther}
                                    required={true}
                                    className="edit_job form__field_select selectAsealign"
                                    value={this.state.IssuingBankEdit}
                                  >
                                    <option value="">
                                      Select Issuing Bank
                                    </option>
                                    {BankIssueIdArr !== ""
                                      ? BankIssueIdArr.map(
                                          (item, indexdata) => {
                                            return (
                                              <option
                                                key={indexdata}
                                                value={item.key}
                                              >
                                                {item.value}
                                              </option>
                                            );
                                          }
                                        )
                                      : ""}
                                  </Form.Select>
                                </FloatingLabel>
                              </div>
                              <div className="col-md-6 form-group input-user">
                                <FloatingLabel
                                  className="lableWidth"
                                  label="BG Actual  Value *"
                                >
                                  <Form.Control
                                    className="edit_job_edit form__field"
                                    type="number"
                                    disabled={
                                      this.state.StatusCode >= 60 ||
                                      this.state.parentReqID !== null
                                        ? true
                                        : false
                                    }
                                    required={true}
                                    name="BGValueActualEdit"
                                    onChange={this.handleNumberChange}
                                    value={this.state.BGValueActualEdit}
                                    placeholder="BG Value"
                                  />
                                </FloatingLabel>
                              </div>
                            </div>

                            {(this.state.ReqStatusValue !==
                              "Received from Bank" &&
                              this.state.ReqStatus >= "70" &&
                              this.state.ReqStatus >= 70) ||
                            (this.state.ReqStatus === "80" &&
                              this.state.ReqStatus !== 150) ? (
                              <span>
                                <span className="DottedClass"></span>
                                <div className="row mt-2">
                                  <div className="col-md-6 form-group input-user ">
                                    <label
                                      className={
                                        this.state.StatusCode >= 80
                                          ? "moveDataStart labelClass"
                                          : "moveDataStart"
                                      }
                                    >
                                      Customer Hand Over Date *
                                    </label>
                                    <DatePicker
                                      onChange={
                                        this.handleChangeCustomerHandOverDate
                                      }
                                      selected={this.state.CustomerHandOverDate}
                                      dateFormat="dd-MMM-yyyy"
                                      minDate={
                                        this.state.StartCustomerHandOverDate
                                      }
                                      maxDate={this.state.lasttdatemax}
                                      required
                                      placeholderText="Customer Hand Over Date *"
                                      className="form-control"
                                      disabled={this.state.StatusCode >= 80}
                                    />

                                    {/* <FloatingLabel controlId="floatingSelect" className="lableWidth" label="Preferred Bank *">
                                <Form.Select aria-label="Preferred Bank" name="PreferredBankEdit" onChange={this.handleDataChangeOther} required={true} className="edit_job form__field_select selectAsealign" value={this.state.PreferredBankEdit}>
                                  <option value=''>Select Preferred Bank</option>
                                  {BankIdArr !== ''?
                                    BankIdArr.map((item, indexdata) => {
                                    return (
                                      <option key={indexdata} value={item.key}>
                                      {item.value}</option>
                                      );
                                    })
                                    : ''}
                                </Form.Select>
                              </FloatingLabel> */}
                                  </div>
                                </div>
                              </span>
                            ) : (
                              ""
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                        {this.state.StatusCode > 60 &&
                        this.state.ReqStatus !== 150 ? (
                          <span>
                            {/* <div className="col-md-6 form-group input-user"> */}
                            {/* <FloatingLabel className="lableWidth" label="BG # *">
                                  <Form.Control className="edit_job_edit form__field" type="text"  required={true} name="BGNumEdit"  onChange={this.handleDataChangeOther} value={this.state.BGNumEdit} placeholder="Finance Notes"/>
                              </FloatingLabel> */}
                            {/* </div> */}
                            {this.state.ReqStatus === "80" ||
                            this.state.ReqStatus === 80 ||
                            this.state.ReqStatus === "100" ||
                            (this.state.ReqStatus === 100 &&
                              this.state.ReqStatus !== 150) ? (
                              <span>
                                <span className="DottedClass"></span>
                                <div className="row mt-1 ">
                                  <div className="col-md-6 form-group input-user">
                                    <label
                                      className={
                                        this.state.StatusCode > 80
                                          ? "moveDataStart labelClass"
                                          : "moveDataStart"
                                      }
                                    >
                                      Date of return by Customer *
                                    </label>
                                    <DatePicker
                                      onChange={
                                        this.handleChangeDateOfReturnByCustomer
                                      }
                                      selected={
                                        this.state.DateOfReturnByCustomer
                                      }
                                      dateFormat="dd-MMM-yyyy"
                                      minDate={this.state.ValidityToEdit}
                                      maxDate={this.state.lasttdatemax}
                                      required
                                      placeholderText="Date of return by Customer *"
                                      className="form-control"
                                      disabled={
                                        // this.state.DateOfReturnByCustomer || // Disable if true
                                        this.state.StatusCode > 80 || // Disable if StatusCode is greater than 80
                                        (this.state.parentReqID !== null &&
                                          !(
                                            this.state.StatusCode === 70 ||
                                            this.state.StatusCode === 80
                                          )) // Disable if parentReqID is not null and StatusCode is NOT 70 or 80
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </span>
                            ) : (
                              ""
                            )}

                            {this.state.ReqStatus === 100 ||
                            (this.state.ReqStatus === "100" &&
                              this.state.ReqStatus !== 150) ? (
                              <div className="row mt-1">
                                <div className="col-md-6 form-group input-user DateAlign">
                                  <label className="moveDataStart">
                                    Surrender Date{" "}
                                    {this.state.ReqStatus === 100 ||
                                    (this.state.ReqStatus === "100" &&
                                      this.state.ReqStatus !== 150)
                                      ? "*"
                                      : ""}
                                  </label>
                                  <DatePicker
                                    onChange={this.handleChangeSurrenderEdit}
                                    selected={this.state.SurrenderEdit}
                                    dateFormat="dd-MMM-yyyy"
                                    minDate={this.state.ValidityToEdit}
                                    maxDate={this.state.lasttdatemax}
                                    disabled={
                                      // Disable if StatusCode is greater than 80
                                      this.state.parentReqID !== null &&
                                      !(this.state.StatusCode >= 80) // Disable if parentReqID is not null
                                        ? true
                                        : false
                                    }
                                    required={
                                      this.state.ReqStatus === 100 ||
                                      (this.state.ReqStatus === "100" &&
                                        this.state.ReqStatus !== 150)
                                        ? true
                                        : false
                                    }
                                    placeholderText={
                                      this.state.ReqStatus === 100 ||
                                      (this.state.ReqStatus === "100" &&
                                        this.state.ReqStatus !== 150)
                                        ? "Date of Surrender to Bank *"
                                        : "Date of Surrender to Bank"
                                    }
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-6 form-group input-user DateAlign">
                                  <label className="moveDataStart">
                                    Date of discharge of liability by Bank{" "}
                                    {this.state.ReqStatus === 100 ||
                                    this.state.ReqStatus === "100"
                                      ? "*"
                                      : ""}
                                  </label>
                                  <DatePicker
                                    onChange={this.handleChangeDischargeDate}
                                    selected={
                                      this.state.DischargeOfLiabilityByBankEdit
                                    }
                                    dateFormat="dd-MMM-yyyy"
                                    minDate={this.state.ValidityToEdit}
                                    maxDate={this.state.lasttdatemax}
                                    disabled={
                                      // Disable if StatusCode is greater than 80
                                      this.state.parentReqID !== null &&
                                      !(this.state.StatusCode >= 80) // Disable if parentReqID is not null and StatusCode is NOT 70 or 80
                                        ? true
                                        : false
                                    }
                                    required={
                                      this.state.ReqStatus === 100 ||
                                      (this.state.ReqStatus === "100" &&
                                        this.state.ReqStatus !== 150)
                                        ? true
                                        : false
                                    }
                                    placeholderText={
                                      this.state.ReqStatus === 100 ||
                                      (this.state.ReqStatus === "100" &&
                                        this.state.ReqStatus !== 150)
                                        ? "Date of discharge of liability by Bank *"
                                        : "Date of discharge of liability by Bank"
                                    }
                                    className="form-control"
                                  />
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                        {
                          this.state.appBtnFin === true ? (
                            <div className="row mt-1 ">
                              <span className="DottedClass"></span>
                              <div className="col-md-12 form-group input-user">
                                <FloatingLabel
                                  className="lableWidth"
                                  label="Requster Notes "
                                >
                                  <Form.Control
                                    className="edit_job_edit form__field "
                                    type="text"
                                    disabled={true}
                                    maxLength={255}
                                    name="NotesEdit"
                                    onChange={this.handleDataChangeOther}
                                    value={this.state.LatestReqstorNote}
                                    placeholder="Notes"
                                  />
                                </FloatingLabel>
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                          // <div className='row mt-1 '>
                          //   <span className='DottedClass'></span>
                          //   <div className="col-md-12 form-group input-user">
                          //       <FloatingLabel className="lableWidth" label="Finance Notes ">
                          //         <Form.Control className="edit_job_edit form__field " type="text" disabled={true} maxLength={255} name="NotesEdit"  onChange={this.handleDataChangeOther} value={this.state.NotesEdit} placeholder="Notes"/>
                          //     </FloatingLabel>
                          //   </div>
                          // </div>
                        }
                        {this.state.appBtnFin === true ? (
                          <div className="row mt-1">
                            <div className="col-md-12 form-group input-user">
                              <FloatingLabel
                                className="lableWidth"
                                label="Finance Notes "
                              >
                                <Form.Control
                                  className="edit_job_edit form__field "
                                  type="text"
                                  maxLength={255}
                                  name="NotesEditOther"
                                  onChange={this.handleDataChangeOther}
                                  value={this.state.NotesEditOther}
                                  placeholder="Notes"
                                />
                              </FloatingLabel>
                            </div>
                          </div>
                        ) : (
                          <div className="row mt-1">
                            <div className="col-md-12 form-group input-user">
                              <FloatingLabel
                                className="lableWidth"
                                label="Notes "
                              >
                                <Form.Control
                                  className="edit_job_edit form__field "
                                  type="text"
                                  maxLength={255}
                                  name="NotesEditOther"
                                  onChange={this.handleDataChangeOther}
                                  value={this.state.NotesEditOther}
                                  placeholder="Notes"
                                />
                              </FloatingLabel>
                            </div>
                          </div>
                        )}
                        <div className="row mt-2">
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Status *"
                            >
                              <Form.Select
                                aria-label="Status"
                                name="ReqStatus"
                                onChange={this.handleDataChangeOtherStatus}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.ReqStatus}
                                disabled={
                                  this.state.parentReqID !== null &&
                                  this.state.InitialReqStatus > 80
                                }
                              >
                                <option value="">Select Status</option>
                                {permissionArr.length > 0
                                  ? permissionArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={
                                            item.DestinationStatusCodeValue
                                          }
                                        >
                                          {item.DestinationStatus}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-3 form-group input-user mt-3">
                            <button
                              type="submit"
                              disabled={
                                this.state.editReq === false ||
                                this.state.childReqID !== null ||
                                permissionArr.length === 0
                                  ? true
                                  : false
                              }
                              className="btnval btn btn-success font_size"
                            >
                              Save
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-use mt-3">
                            <button
                              type="button"
                              onClick={this.handleClose}
                              className="btnval btn btn-danger font_size"
                            >
                              Cancel
                            </button>
                          </div>
                          {this.state.ReqStatusValue === "Customer" &&
                          this.state.appBtnFin === false &&
                          this.state.appBtn === false &&
                          bgDetailsDataCustomer?.CustomerHandOverDate !==
                            "9999-12-31" &&
                          this.state.renewalFlag === true ? (
                            <div className="col-md-3 form-group input-use mt-3">
                              <button
                                type="button"
                                disabled={!this.state.renewalFlag}
                                onClick={this.handleBgRenewModal}
                                className="btnval btn btn-warning font_size"
                              >
                                Initiate Renewal
                              </button>
                            </div>
                          ) : null}
                        </div>
                        <div className="row mt-3 ">
                          <span className="DottedClass"></span>
                          <div className="col-md-12 form-group input-user">
                            <Table bordered responsive>
                              <thead>
                                <th className="alginCenter">Document Type</th>
                                <th className="alginCenter">Document Name</th>
                                <th className="alginCenter">Description</th>
                                <th className="alginCenter">Uploaded By/On</th>
                                <th className="alginCenter taskWithPlus">
                                  {this.state.editReq === false ||
                                  permissionArr.length === 0 ? (
                                    ""
                                  ) : (
                                    <span
                                      className="saveBtnUsPl cursorPoint"
                                      onClick={() => {
                                        this.handleShowModal();
                                      }}
                                    >
                                      <FaPlusCircle />
                                    </span>
                                  )}
                                </th>
                                <th className="alginCenter"></th>
                              </thead>
                              <tbody>
                                {documentArr.length > 0 ? (
                                  documentArr.map((item, indexdata) => {
                                    return (
                                      <tr key={indexdata}>
                                        <td className="alginCenter">
                                          {item.SelectionValue}
                                        </td>
                                        <td className="alginCenter">
                                          {item.FileName}
                                        </td>
                                        <td className="alginCenter">
                                          {item.Description}
                                        </td>
                                        <td className="alginCenter">
                                          {item.UploadedBy +
                                            " / " +
                                            item.UploadedOn}
                                        </td>
                                        {item.DeleteFlag === true &&
                                        this.state.editReq === true &&
                                        permissionArr.length > 0 ? (
                                          <td className="alginCenter taskWithPlus">
                                            <span
                                              className="saveBtnUsMi cursorPoint"
                                              onClick={() =>
                                                this.handleDataRemoveImage(
                                                  indexdata
                                                )
                                              }
                                            >
                                              <FaMinusCircle />
                                            </span>
                                          </td>
                                        ) : (
                                          <td className="alginCenter taskWithPlus"></td>
                                        )}
                                        <td className="alginCenter cursorPoint">
                                          <span>
                                            <FaDownload
                                              onClick={() => {
                                                if (
                                                  item?.VirusScanStatus === "C"
                                                ) {
                                                  this.handleImageDownload(
                                                    item.FileName,
                                                    item.DocumentID
                                                  );
                                                }
                                              }}
                                              style={{
                                                color:
                                                  item?.VirusScanStatus === "C"
                                                    ? "green"
                                                    : "grey",
                                                cursor:
                                                  item?.VirusScanStatus === "C"
                                                    ? "pointer"
                                                    : "not-allowed",
                                              }}
                                              title={
                                                item?.VirusScanStatus === "C"
                                                  ? "Download"
                                                  : "Download Disabled"
                                              }
                                            />
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td className="alginCenter" colSpan={5}>
                                      No Document Uploaded yet!
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>

                        {this.state.childReqID && (
                          <div className="row mt-2">
                            <strong className="highlightedNote">
                              Note : This BG has been renewed. Refer to Req No.{" "}
                              {this.state.childReqID} for further updates.
                            </strong>
                          </div>
                        )}
                        <div className="row">
                          <span className="text-danger">
                            Note: The uploaded file will be scanned . A
                            greyed-out download icon {"( "}
                            <span
                              style={{
                                color: "grey",
                              }}
                            >
                              <FaDownload />
                            </span>
                            {" ) "}
                            indicates that the file is infected and cannot be
                            downloaded. A green download icon {"( "}
                            <span
                              style={{
                                color: "green",
                              }}
                            >
                              <FaDownload />
                            </span>
                            {" ) "}
                            indicates that the file is clean and can be safely
                            downloaded.{" "}
                          </span>
                        </div>
                      </form>
                    ) : (
                      ""
                    )}

                    {this.state.openStatus === "Approval" ? (
                      <form
                        className="pr-5 mb-5 formUser"
                        method="POST"
                        onSubmit={this.handleSubmitAproval}
                      >
                        <div className="row">
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Business Unit *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="DivisionEdit"
                                disabled={true}
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.DivisionEdit}
                              >
                                <option value="">Select Business Unit</option>
                                {DivisionIdArr !== ""
                                  ? DivisionIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Branch *"
                            >
                              <Form.Select
                                aria-label="Division"
                                name="Branch"
                                disabled={true}
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.Branch}
                              >
                                <option value="">Select Branch</option>
                                {listBranch !== ""
                                  ? listBranch.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-6 form-group input-user">
                            {/* <FloatingLabel
                            controlId="floatingSelect"
                            className="lableWidth"
                            label="SAP Cust Name"
                          >
                            <Form.Select
                              aria-label="Division"
                              disabled={true}
                              name="SAPCustEdit"
                              onChange={this.handleDataChangeOther}
                              required={true}
                              className="edit_job form__field_select selectAsealign"
                              value={this.state.SAPCustEdit}
                            >
                              {SapCustIdArr !== ""
                                ? SapCustIdArr.map((item, indexdata) => {
                                    return (
                                      <option key={indexdata} value={item.key}>
                                        {item.value}
                                      </option>
                                    );
                                  })
                                : ""}
                            </Form.Select>
                          </FloatingLabel> */}
                            <Select
                              onChange={this.handleDataChangeDropEdit}
                              value={selectedOptionEdit}
                              options={options}
                              className="font_size edit_job "
                              placeholder="Select SAP Cust Name"
                              isClearable
                              isDisabled
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Type *"
                            >
                              <Form.Select
                                aria-label="Type"
                                name="IsOrderTenderEdit"
                                disabled={true}
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.IsOrderTenderEdit}
                              >
                                <option value="">Select Type</option>
                                <option value={false}>Order</option>
                                <option value={true}>Tender</option>
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender # *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                disabled={true}
                                type="text"
                                required={true}
                                name="OrderNumEdit"
                                onChange={this.handleDataChangeOther}
                                value={this.state.OrderNumEdit}
                                placeholder="Order #"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user DateAlign">
                            <label className="moveDataStart dateDis">
                              Order/Tender Date *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStart}
                              selected={this.state.OrderDateEdit}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDateOtData}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Order/Tender Date *"
                              className="form-control"
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Order/Tender Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                disabled={true}
                                type="number"
                                required={true}
                                name="OrderValueEdit"
                                onChange={this.handleDataChangeOther}
                                value={this.state.OrderValueEdit}
                                placeholder="Order Value"
                              />
                            </FloatingLabel>
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="BG Value *"
                            >
                              <Form.Control
                                className="edit_job_edit form__field"
                                disabled={true}
                                type="number"
                                required={true}
                                name="BGValueEdit"
                                onChange={this.handleDataChangeOther}
                                value={this.state.BGValueEdit}
                                placeholder="BG Value"
                              />
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6 form-group input-user DateAlign">
                            <label className="moveDataStart dateDis">
                              Validity from *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeStart}
                              selected={this.state.ValidityFromEdit}
                              dateFormat="dd-MMM-yyyy"
                              // minDate={this.state.startDate}
                              minDate={this.state.lasttdateValidity}
                              required
                              placeholderText="Validity from *"
                              className="form-control"
                              disabled={true}
                            />
                          </div>
                          <div className="col-md-6 form-group input-user DateAlign">
                            <label className="moveDataStart dateDis">
                              Validity To *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeEnd}
                              selected={this.state.ValidityToEdit}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDate}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Validity To *"
                              className="form-control"
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-6 form-group input-user DateAlign">
                            <label className="moveDataStart dateDis">
                              Claim period *
                            </label>
                            <DatePicker
                              onChange={this.handleChangeEnd}
                              selected={this.state.ClaimPeriodEdit}
                              dateFormat="dd-MMM-yyyy"
                              minDate={this.state.startDate}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Claim period *"
                              className="form-control"
                              disabled={true}
                            />
                            {/* <FloatingLabel className="lableWidth" label="Claim period *">
                                 <Form.Control className="edit_job_edit form__field" type="text" required={true} name="Work"  onChange={this.handleDataChangeOther} value={this.state.Work} placeholder="Claim period"/>
                             </FloatingLabel> */}
                          </div>
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="BG Type *"
                            >
                              <Form.Select
                                aria-label="Type"
                                name="BGTypeEdit"
                                disabled={true}
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.BGTypeEdit}
                              >
                                <option value="">Select Type</option>
                                {BgTypeIdArr !== ""
                                  ? BgTypeIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-1">
                          {/* <div className="col-md-6 form-group input-user selectAsealign">
                              <button className='btn btn-primary font_size ' onClick={() => {this.handleShowModal()}}>Document Upload</button>
                              <span>&nbsp;&nbsp; 2 document(s) uploaded.</span>
                           </div> */}
                          <div className="col-md-6 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelect"
                              className="lableWidth"
                              label="Preferred Bank *"
                            >
                              <Form.Select
                                aria-label="Preferred Bank"
                                disabled={true}
                                name="PreferredBankEdit"
                                onChange={this.handleDataChangeOther}
                                required={true}
                                className="edit_job form__field_select selectAsealign"
                                value={this.state.PreferredBankEdit}
                              >
                                <option value="">Select Preferred Bank</option>
                                {BankIdArr !== ""
                                  ? BankIdArr.map((item, indexdata) => {
                                      return (
                                        <option
                                          key={indexdata}
                                          value={item.key}
                                        >
                                          {item.value}
                                        </option>
                                      );
                                    })
                                  : ""}
                              </Form.Select>
                            </FloatingLabel>
                          </div>
                          {/* <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            className="lableWidth"
                            label="Stamp Paper Value *"
                          >
                            <Form.Control
                              className="edit_job_edit form__field"
                              type="number"
                              disabled={true}
                              required={true}
                              name="StampPaperValue"
                              onChange={this.handleNumberChange}
                              value={this.state.StampPaperValue}
                              placeholder="Stamp Paper Value"
                            />
                          </FloatingLabel>
                        </div> */}
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-12 form-group input-user">
                            <FloatingLabel
                              className="lableWidth"
                              label="Notes "
                            >
                              <Form.Control
                                className="edit_job_edit form__field "
                                maxLength={255}
                                type="text"
                                name="NotesApprovel"
                                onChange={this.handleDataChangeOther}
                                value={this.state.NotesApprovel}
                                placeholder="Notes"
                              />
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-4 form-group input-user"></div>
                          <div className="col-md-3 form-group input-user">
                            <button
                              type="submit"
                              disabled={
                                this.state.appBtn === false ? true : false
                              }
                              className="btnval btn btn-success font_size"
                            >
                              Approve
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <button
                              type="button"
                              disabled={
                                this.state.appBtn === false ? true : false
                              }
                              onClick={this.handleSubmitReject}
                              className="btnval btn btn-danger font_size"
                            >
                              Reject
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user"></div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12 form-group input-user">
                            <Table bordered responsive>
                              <thead>
                                <th className="alginCenter">Document Type</th>
                                <th className="alginCenter">Document Name</th>
                                <th className="alginCenter">Description</th>
                                <th className="alginCenter">Uploaded By/On</th>
                                <th className="alginCenter"></th>
                              </thead>
                              <tbody>
                                {documentArr.length > 0 ? (
                                  documentArr.map((item, indexdata) => {
                                    return (
                                      <tr key={indexdata}>
                                        <td className="alginCenter">
                                          {item.SelectionValue}
                                        </td>
                                        <td className="alginCenter">
                                          {item.FileName}
                                        </td>
                                        <td className="alginCenter">
                                          {item.Description}
                                        </td>
                                        <td className="alginCenter">
                                          {item.UploadedBy +
                                            " / " +
                                            item.UploadedOn}
                                        </td>
                                        <td className="alginCenter cursorPoint">
                                          <span>
                                            <FaDownload
                                              onClick={() => {
                                                if (
                                                  item?.VirusScanStatus === "C"
                                                ) {
                                                  this.handleImageDownload(
                                                    item.FileName,
                                                    item.DocumentID
                                                  );
                                                }
                                              }}
                                              style={{
                                                color:
                                                  item?.VirusScanStatus === "C"
                                                    ? "green"
                                                    : "grey",
                                                cursor:
                                                  item?.VirusScanStatus === "C"
                                                    ? "pointer"
                                                    : "not-allowed",
                                              }}
                                              title={
                                                item?.VirusScanStatus === "C"
                                                  ? "Download"
                                                  : "Download Disabled"
                                              }
                                            />
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td className="alginCenter" colSpan={5}>
                                      No Document Uploaded yet!
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </form>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        )}
        <Modal
          show={this.state.showModalBig}
          onHide={this.handleCloseModalBig}
          className="backModalBig"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="titleDataOther"
            >
              Uploaded Document
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid">
            <div className="container">
              {/* <TransformWrapper> */}
              {/* <div className="tools">
                    <button onClick={() => zoomIn()}>+</button>
                    <button onClick={() => zoomOut()}>-</button>
                    <button onClick={() => resetTransform()}>x</button>
                  </div> */}
              {/* <TransformComponent contentClass="mainImage"> */}
              {/* <FileViewer
                              fileType={this.state.typeImage}
                              filePath={this.state.viewFile}
                              
                             /> */}
              {/* <DocViewer documents={this.state.viewFile} /> */}
              <iframe
                src={this.state.viewFile}
                className="mainImage"
                width="1040"
                height="500"
              ></iframe>
              {/* </TransformComponent>
                </TransformWrapper> */}
            </div>
          </Modal.Body>
          {/* <Modal.Footer className="footerModel">
                  <p className='contentzoom'>Use the mouse scroll to zoom in and zoom out, and click and drag specific portions of the image,of interest to you.</p>
            </Modal.Footer> */}
        </Modal>
        <Modal
          show={this.state.showModal}
          onHide={this.handleCloseModal}
          dialogClassName="custom-dialog"
          className="backModal"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header className="headerUpload" closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="titleData"
            >
              Upload Document
            </Modal.Title>
          </Modal.Header>
          <form
            className="pr-5 formUser"
            method="POST"
            encType="multipart/form-data"
            onSubmit={this.handleChangeImage}
          >
            <Modal.Body className="show-grid modelImageBox">
              <div className="">
                <div className="rowUser justify-content-center imageUploadClass">
                  <div className="rowImage">
                    <div className="imagecol">
                      <FloatingLabel
                        controlId="floatingSelect"
                        className="lableWidth"
                        label="Doc Type *"
                      >
                        <Form.Select
                          aria-label="Status"
                          name="ImageType"
                          onChange={this.handleDataChangeOtherImageType}
                          required={true}
                          className="edit_job form__field_select selectAsealign"
                          value={this.state.ImageType}
                        >
                          <option value="">Select</option>
                          {selectionImage.length > 1
                            ? selectionImage.map((item, indexdata) => {
                                return (
                                  <option
                                    key={indexdata}
                                    value={item.SelectionType}
                                  >
                                    {item.SelectionValue}
                                  </option>
                                );
                              })
                            : ""}
                        </Form.Select>
                      </FloatingLabel>
                      {/* // <img className='mainImage cursorPoint' src={this.state.image} onClick={this.handleShowModalBig} height="175" width="175"/> */}
                      {/* <iframe src={this.state.image} onClick={this.handleShowModalBig} className="mainImage cursorPoint" width='200' height='200' frameBorder='0'></iframe> */}
                      {this.state.imageData !== "" &&
                      this.state.imageData !== null &&
                      this.state.imageData !== undefined ? (
                        <p className="fileNameClass">{this.state.imageId}</p>
                      ) : (
                        <div className="profile-pic">
                          <label className="-label" htmlFor="file">
                            <span>&nbsp;</span>
                          </label>
                          <input
                            id="file"
                            type="file"
                            name="fileimage"
                            onChange={this.handleChangeImageDataOther}
                            accept={this.state.AllowedFileExtensions}
                          />
                          <img src={this.state.image} id="output" width="200" />
                        </div>
                      )}
                      <p className="photoClass">
                        Supported file formats :{" "}
                        {this.state.AllowedFileExtensions}
                        <br />
                        Maximum file size : {this.state.MaxAllowedSize}
                      </p>
                      {/* <FloatingLabel
                        controlId="floatingTextarea2"
                        label="Description *"
                      > */}
                      <Form.Control
                        as="textarea"
                        placeholder="Description *"
                        name="Comment"
                        required={true}
                        // style={{ height: '185px' }}
                        onChange={this.handleDataChangeOther}
                        value={this.state.duration}
                        className="font_size des_text"
                      />
                      {/* </FloatingLabel> */}
                      <p className="photoClass mt-2">
                        <b>
                          Note: The uploaded documents will be saved only on the
                          click of the Save button in the next screen.
                        </b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="footerModel">
              <button className="btn btn-success fontSize">Upload</button>
            </Modal.Footer>
          </form>
        </Modal>
        {this.state.lodingImagData === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
